import React, { useLayoutEffect, useRef, useEffect, useState } from "react"
import VisibilitySensor from 'react-visibility-sensor'
import { gsap } from "gsap";
import useWindowSize from "../components/hooks"
import "../components/summer-development.scss"
import "../components/pages.scss"
import { StaticImage } from "gatsby-plugin-image"
import summerMobileHeader from "../images/Summer_Mobile_Header.svg"

export default function SummerSVG() {
	const [desktopViewState, setDesktopViewState] = useState(null);
	const summerItems = useRef([]);
	const summerSVG = useRef();
	const [summerInt, setSummerInt] = useState(null);
	const accordionItem = useRef([]);
	const [accordInt, setAccordInt] = useState({currentOpen: null, prevOpen: null, open: false});
	const triggers = useRef([]);
	const size = useWindowSize();

    useEffect(() => {
		const mql = window.matchMedia('(min-width: 1024px)');
		setDesktopViewState(mql.matches);
	}, [size, desktopViewState]);

    useEffect(() => {
    	let q = gsap.utils.selector(summerSVG.current);
    	let tl = gsap.timeline()
    	.set(q(".text"), {display: 'none'})
    	.set(q(".rings"), {display: 'none', opacity: 0})
    	.set(q(".center-icon"), {scale: .6, transformOrigin: '50% 0%'})
    	.set(q(".summer-circle-item .summer-circle"), {scale: .85, transformOrigin: '50% 50%'})
    	.set(q(".summer-circle-item"), {opacity: 0})
    	.set(q(".icon-text"), {scale: 1, opacity: 1, transformOrigin: 'center center', duration: .5})

    	for(let x = 0; x < triggers.current.length; x++) {
    		let triggerParent = gsap.utils.selector(triggers.current[x]);
	    	let tl = gsap.timeline()
	    	.set(triggerParent(".rings"), {display: 'none', opacity: 0})
	    	.set(triggerParent(".icon"), {scale: .6, transformOrigin: '50% 0%'})
	    	.set(triggerParent(".summer-circle-item .summer-circle"), {scale: .9, transformOrigin: '50% 50%'})
	    	// .set(triggerParent(".summer-circle-item"), {opacity: 0})
	    	.set(triggerParent(".icon-text"), {scale: 1, opacity: 1, transformOrigin: 'center center', duration: .5})		
    	}
    	

    }, []); 

    function handleClickSummer(int) {
    	if(int === summerInt) {
    		closeSummerItem(null);
    		setSummerInt(null);
    	} else {
    		closeSummerItem(int);
    		openSummerItem(int);
    		setSummerInt(int);
    	}
    }

    function openSummerItem(int) {
    	let q = gsap.utils.selector(summerItems.current[int]);
    	let tl = gsap.timeline()
    	.set(summerItems.current[int], {zIndex: 15, pointerEvents: 'none'})
    	.to(q(".icon-text"), {scale: .5, opacity: 0, transformOrigin: 'center center', duration: .5})
		.to(q(".center-icon"), {scale: 1, transformOrigin: '50% 0%', duration: .5}, "-=.4")
		.to(q(".summer-circle-item .summer-circle"), {scale: 1, transformOrigin: '50% 50%'}, "-=.5")    	
		.to(q(".rings"), {display: 'block', opacity: 1, rotate: 360, ease: 'power4', duration: 1, transformOrigin: '50% 50%'}, "-=.5")
		.fromTo(q(".text"), {opacity: 0, y: -60}, {display: 'block', y: 0, opacity: 1, ease: 'power4'}, "-=.6")
		.set(summerItems.current[int], {pointerEvents: 'auto'})
    }

    function closeSummerItem(int) {
    	let allItems = summerItems.current;
    	for(let x = 0; x < allItems.length; x++) {
    		if(x === int) { continue; }
    		let q = gsap.utils.selector(summerItems.current[x]);
    		let tl = gsap.timeline()
    		.set(summerItems.current[x], {zIndex: 10, pointerEvents: 'none'})
    		.to(q(".text"), {display: 'none', opacity: 0, y: -40, duration: .2})
    		.to(q(".rings"), {display: 'none', opacity: 0, rotate: 0,})
    		.to(q(".center-icon"), {scale: .6, transformOrigin: '50% 0%'}, "-=.5")
    		.to(q(".summer-circle-item .summer-circle"), {scale: .85, transformOrigin: '50% 50%'}, "-=.4")
    		.to(q(".icon-text"), {scale: 1, opacity: 1, transformOrigin: 'center center', duration: .5}, "-=.6")	
    		.set(summerItems.current[x], {zIndex: 10, pointerEvents: 'auto'})
    	}
    }

    // useEffect(() => {

    // }, [summerInt]);

    function onChange(isVisible) {
    	if(summerInt !== null) {
	    	closeSummerItem(null);
	    	setSummerInt(null);
	    }
    	console.log(isVisible, 'vis');
    	if(isVisible) {
    		let tl = gsap.timeline({paused: true})
    		let allItems = summerItems.current;
			let q1 = gsap.utils.selector(summerItems.current[4]);
			let q2 = gsap.utils.selector(summerItems.current[2]);
			let q3 = gsap.utils.selector(summerItems.current[0]);
			let q4 = gsap.utils.selector(summerItems.current[1]);
			let q5 = gsap.utils.selector(summerItems.current[3]);
			let q6 = gsap.utils.selector(summerItems.current[5]);

    		tl.fromTo(q1(".summer-circle-item"), {opacity: 0, x: 40, y: -40}, {opacity: 1, x: 0, y: 0, transformOrigin: '50% 50%', duration: .5}, "-=.35")    	
    		.to(q1(".summer-circle-item .summer-circle"), {scale: 1, transformOrigin: '50% 50%', duration: .5}, "-=.35")    	
			.to(q1(".rings"), {display: 'block', opacity: 1, rotate: 360, ease: 'power4', duration: .5, transformOrigin: '50% 50%'}, "-=.35")

			tl.fromTo(q2(".summer-circle-item"), {opacity: 0, x: 20, y: -40}, {opacity: 1, x: 0, y: 0, transformOrigin: '50% 50%', duration: .5}, "-=.35")
			.to(q2(".summer-circle-item .summer-circle"), {scale: 1, transformOrigin: '50% 50%', duration: .5}, "-=.35")    	
			.to(q2(".rings"), {display: 'block', opacity: 1, rotate: 360, ease: 'power4', duration: .5, transformOrigin: '50% 50%'}, "-=.35")

			tl.fromTo(q3(".summer-circle-item"), {opacity: 0, x: 10, y: -40}, {opacity: 1, x: 0, y: 0, transformOrigin: '50% 50%', duration: .5}, "-=.35")
			.to(q3(".summer-circle-item .summer-circle"), {scale: 1, transformOrigin: '50% 50%', duration: .5}, "-=.35")    	
			.to(q3(".rings"), {display: 'block', opacity: 1, rotate: 360, ease: 'power4', duration: .5, transformOrigin: '50% 50%'}, "-=.35")

			tl.fromTo(q4(".summer-circle-item"), {opacity: 0, x: -10, y: -40}, {opacity: 1, x: 0, y: 0, transformOrigin: '50% 50%', duration: .5}, "-=.35")
			.to(q4(".summer-circle-item .summer-circle"), {scale: 1, transformOrigin: '50% 50%', duration: .5}, "-=.35")    	
			.to(q4(".rings"), {display: 'block', opacity: 1, rotate: 360, ease: 'power4', duration: .5, transformOrigin: '50% 50%'}, "-=.35")

			tl.fromTo(q5(".summer-circle-item"), {opacity: 0, x: -20, y: -40}, {opacity: 1, x: 0, y: 0, transformOrigin: '50% 50%', duration: .5}, "-=.35")
			.to(q5(".summer-circle-item .summer-circle"), {scale: 1, transformOrigin: '50% 50%', duration: .5}, "-=.35")    	
			.to(q5(".rings"), {display: 'block', opacity: 1, rotate: 360, ease: 'power4', duration: .5, transformOrigin: '50% 50%'}, "-=.35")

			tl.fromTo(q6(".summer-circle-item"), {opacity: 0, x: -40, y: -40}, {opacity: 1, x: 0, y: 0, transformOrigin: '50% 50%', duration: .5}, "-=.35")
			.to(q6(".summer-circle-item .summer-circle"), {scale: 1, transformOrigin: '50% 50%', duration: .5}, "-=.35")    	
			.to(q6(".rings"), {display: 'block', opacity: 1, rotate: 360, ease: 'power4', duration: .5, transformOrigin: '50% 50%'}, "-=.35")

			tl.delay(1).play(0);
			tl.eventCallback('onComplete', closeSummerItem, [null]);
			
    	}
    }

    function handleClickAccordion(int) {
    	if(int === accordInt['currentOpen']) {
    		// console.log('1a', accordInt);
    		setAccordInt({currentOpen: null, prevOpen: accordInt['currentOpen'], open: false});
    	} else if(accordInt['currentOpen'] === null) {
    		// console.log('2a', accordInt);
    		setAccordInt({currentOpen: int, prevOpen: int, open: true});
    	} else {
    		// console.log('3a', accordInt);
    		setAccordInt({currentOpen: int, prevOpen: accordInt['currentOpen'], open: true});
    	}
    }

    useEffect(() => {
    	if(accordInt['open'] === false) {
    		// console.log('1', accordInt);
    		closeAccordion(accordInt['prevOpen']);
    	} else if(accordInt['open'] === true && accordInt['currentOpen'] === accordInt['prevOpen']) {	
    		// console.log('2', accordInt);
    		openAccordion(accordInt['currentOpen']);
    	} else {
    		// console.log('3', accordInt);
    		closeAccordion(accordInt['prevOpen']);
    		openAccordion(accordInt['currentOpen']);	
    	}

    	// setAccordInt((prevState) => ({...prevState, prevOpen: int}));
    	function closeAccordion(int) {
    		let accordionParent = gsap.utils.selector(accordionItem.current[int]);
    		let tl = gsap.timeline()
    		.to(accordionParent('.accordion__content'), {height: 0, display: 'none', y: -30, opacity: 0})
    		.to(accordionParent(".rings"), {display: 'none', opacity: 0, rotate: 0,}, "-=.5")
    		.to(accordionParent(".icon"), {scale: .6, transformOrigin: '50% 0%'}, "-=.5")
    		.to(accordionParent(".summer-circle-item .summer-circle"), {scale: .9, transformOrigin: '50% 50%'}, "-=.4")
    		.to(accordionParent(".icon-text"), {scale: 1, opacity: 1, transformOrigin: 'center center', duration: .5}, "-=.6")	
    	}

    	function openAccordion(int) {
    		let accordionParent = gsap.utils.selector(accordionItem.current[int]);
    		let tl = gsap.timeline()
    		.fromTo(accordionParent('.accordion__content'), {display: 'block', height: 0, y: -30, opacity: 0}, {height: 'auto', y: 0, opacity: 1})
    		.to(accordionParent(".icon-text"), {scale: .5, opacity: 0, transformOrigin: 'center center', duration: .5}, "-=.5")
			.to(accordionParent(".icon"), {scale: 1, transformOrigin: '50% 0%', duration: .5}, "-=.4")
			.to(accordionParent(".summer-circle-item .summer-circle"), {scale: 1, transformOrigin: '50% 50%'}, "-=.5")    	
			.to(accordionParent(".rings"), {display: 'block', opacity: 1, rotate: 360, ease: 'power4', duration: 1, transformOrigin: '50% 50%'}, "-=.5")
    	}
    }, [accordInt]);

    // function openAccordion(int) {
    // 	let accordionParent = gsap.utils.selector(accordionItem.current[int]);
    // 	let tl = gsap.timeline()
    // 	.fromTo(accordionParent('.accordion__content'), {display: 'block', height: 0}, {height: 'auto'});
    // }

    // function closeAccordion(int) {

    // }

    useEffect(() => {
    	for(let x = 0; x < accordionItem.current.length; x++) {
    		let accordionParent = gsap.utils.selector(accordionItem.current[x]);
    		gsap.to(accordionParent(".accordion__content"), {display: 'none'});
    	}
    }, []);
	
	return (
		<div className="row row-wrapper p-t-40 p-b-40 m-t-40 m-b-40">
            <div className="col-xs-12">
            	<div style={desktopViewState ? {display: 'block'} : {display: 'none'}}>
                    <VisibilitySensor onChange={onChange} partialVisibility={true} offset={{top: -1000}}>
                    	<svg 
                    		ref={summerSVG}
                       		className="summer-development"
                       		version="1.1" 
                       		id="Layer_1" 
                       		xmlns="http://www.w3.org/2000/svg" 
                       		xmlnsXlink="http://www.w3.org/1999/xlink" 
                       		x="0px" 
                       		y="0px"
                       		width="1376.6px" 
                       		height="955.2px" 
                       		viewBox="0 0 1376.6 955.2" 
                       		style={{enableBackground:'new 0 0 1376.6 955.2'}}
                       		xmlSpace="preserve">
	                       	<path className="st0" d="M1034.3,4.9c0,191.1-154.9,346-346,346s-346-154.9-346-346"/>

							<g>
								<rect x="787.4" y="337.6" transform="matrix(0.9815 -0.1916 0.1916 0.9815 -64.9989 159.049)" className="st1" width="5" height="156.1"/>                   	
								<rect x="966.9" y="245.8" transform="matrix(0.8189 -0.5739 0.5739 0.8189 -14.5073 616.3105)" className="st1" width="5" height="170.6"/>
								<rect x="1077.1" y="97" transform="matrix(0.4393 -0.8984 0.8984 0.4393 443.365 1070.9286)" className="st1" width="5" height="166.6"/>
								<rect x="504.8" y="413.2" transform="matrix(0.1934 -0.9811 0.9811 0.1934 62.3345 907.1716)" className="st1" width="156.1" height="5"/>
								<rect x="330.2" y="328.7" transform="matrix(0.5291 -0.8486 0.8486 0.5291 -86.7652 505.9895)" className="st1" width="164.6" height="5"/>
								<rect x="217.5" y="178" transform="matrix(0.894 -0.448 0.448 0.894 -49.2197 152.9126)" className="st1" width="162.3" height="5"/>
								<rect x="136.5" y="0.9" className="st2" width="1108" height="15"/>
								<rect x="387.8" y="55.7" className="st3" width="588.4" height="153.5"/>
								<text transform="matrix(1 0 0 1 568.901 90.3642)" className="st1 st4 st5">SUMMER  </text>
								<text transform="matrix(1 0 0 1 487.101 142.3642)" className="st1 st4 st5">PERFORMANCE  </text>
								<text transform="matrix(1 0 0 1 456.901 194.3642)" className="st1 st4 st5">BY THE NUMBERS</text>
								<rect x="546.3" y="223.2" className="st3" width="271.3" height="49.8"/>
								<text transform="matrix(1 0 0 1 602.152 240.3812)" className="st6 st7 st8">Click to Explore</text>
								<circle className="st9" cx="598" cy="339" r="20.7"/>
								<circle className="st9" cx="775" cy="339" r="20.7"/>
								<circle className="st9" cx="920.4" cy="261.3" r="20.7"/>
								<ellipse transform="matrix(0.4473 -0.8944 0.8944 0.4473 426.4984 978.6449)" className="st9" cx="1005" cy="144.3" rx="20.7" ry="20.7"/>
								<circle className="st9" cx="456.7" cy="261.3" r="20.7"/>
								<circle className="st9" cx="371.2" cy="144.2" r="20.7"/>
							</g>

							<g className="z10 citem-165" onClick={() => {handleClickSummer(0)}} ref={(element) => {summerItems.current[0] = element}}>
								<g className="text">
									<g>
										<path className="st2" d="M713.2,728.6H582L563.8,697l-18.2,31.6H414.4c-13,0-23.5,10.5-23.5,23.5v141.1c0,13,10.5,23.5,23.5,23.5
										h298.7c13,0,23.5-10.5,23.5-23.5V752.1C736.7,739.1,726.1,728.6,713.2,728.6z"/>
										<path className="st10" d="M713.2,917.6H414.4c-13.5,0-24.5-11-24.5-24.5v-141c0-13.5,11-24.5,24.5-24.5H545l18.8-32.6l18.8,32.6
										h130.6c13.5,0,24.5,11,24.5,24.5v141.1C737.7,906.7,726.7,917.6,713.2,917.6z M414.4,729.6c-12.4,0-22.5,10.1-22.5,22.5v141.1
										c0,12.4,10.1,22.5,22.5,22.5h298.7c12.4,0,22.5-10.1,22.5-22.5V752.1c0-12.4-10.1-22.5-22.5-22.5H581.5L563.8,699l-17.7,30.6
										H414.4z"/>
									</g>
									<rect x="424.2" y="766" className="st3" width="279.2" height="135.6"/>
									<text transform="matrix(1 0 0 1 473.083 784.0391)" className="st10 st4 st11">PJM’s all-time, </text>
									<text transform="matrix(1 0 0 1 464.283 816.4391)" className="st10 st4 st11">one-day highest </text>
									<text transform="matrix(1 0 0 1 434.283 848.8391)" className="st10 st4 st11">power use was set in </text>
									<text transform="matrix(1 0 0 1 428.583 881.2391)" className="st10 st4 st11">2006 at </text>
									<text transform="matrix(1 0 0 1 533.683 881.2391)" className="st9 st4 st11">165,563 MW.</text>
								</g>
		                       	<g className="summer-circle-item icon-1">
		                       		<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="492.9556" y1="274.3195" x2="641.8312" y2="457.2888" gradientTransform="matrix(1 0 0 1 0 188)">
		                       			<stop  offset="0" style={{stopColor:"#7FBD1D"}}/>
		                       			<stop  offset="2.708180e-04" style={{stopColor:"#7FBD1D"}}/>
		                       			<stop  offset="0.2524" style={{stopColor:"#82BD1C"}}/>
		                       			<stop  offset="0.424" style={{stopColor:"#8BBD1A"}}/>
		                       			<stop  offset="0.5717" style={{stopColor:"#9ABD17"}}/>
		                       			<stop  offset="0.7059" style={{stopColor:"#B0BE12"}}/>
		                       			<stop  offset="0.8309" style={{stopColor:"#CBBE0C"}}/>
		                       			<stop  offset="0.9476" style={{stopColor:"#EDBF04"}}/>
		                       			<stop  offset="0.9997" style={{stopColor:"#FFBF00"}}/>
		                       			<stop  offset="1" style={{stopColor:"#FFBF00"}}/>
		                       		</linearGradient>
		                       		<circle className="summer-circle st12" cx="565.6" cy="551.6" r="112.5"/>
		                       		<rect x="510.9" y="591.5" className="st3" width="113.8" height="51.6"/>
		                       		<g className="icon-text">
			                       		<text transform="matrix(1 0 0 1 516.7095 609.5255)" className="st10 st4 st11">165,563 </text>
			                       		<text transform="matrix(1 0 0 1 543.3094 636.5255)" className="st10 st4 st11">MW</text>
		                       		</g>
		                       		<g className="rings">
			                       		<path id="Stroke-1_00000065056785029905199080000007005024986761559946_" className="st13" d="M565.6,415.9
			                       			c-72.6,0-131.4,58.8-131.4,131.4S493,678.7,565.6,678.7S697,619.9,697,547.3S638.2,415.9,565.6,415.9z M565.6,419.6
			                       			c70.5,0,127.7,57.2,127.7,127.7S636.2,675,565.6,675C495.1,675,438,617.9,438,547.3S495.1,419.6,565.6,419.6z"/>
			                       		<path id="Stroke-3_00000163035075008154191950000014795222965595380656_" className="st14" d="M565.6,425.1
		                       			c-72.6,0-131.4,58.8-131.4,131.4S493.1,688,565.6,688c72.6,0,131.4-58.8,131.4-131.4S638.2,425.1,565.6,425.1z M565.6,428.9
		                       			c70.5,0,127.7,57.2,127.7,127.7s-57.2,127.7-127.7,127.7s-127.7-57.2-127.7-127.7S495.1,428.9,565.6,428.9z"/>
	                       			</g>
		                       		<path className="center-icon st10" d="M536.5,565.8v3.6h9.6v-3.6h3.6v4.8c0,1.3-1.1,2.4-2.4,2.4h-12c-1.3,0-2.4-1.1-2.4-2.4v-4.8H536.5z
		                       			 M544.8,579.8h-37c-0.6,0-1.2-0.5-1.2-1.2v-53.5c0-0.6,0.5-1.2,1.2-1.2H552v-3.6h-44.3c-2.6,0-4.8,2.1-4.8,4.8v53.5
		                       			c0,2.6,2.1,4.8,4.8,4.8h37L544.8,579.8L544.8,579.8z M532.9,532.7V545h3.6v-11.1h8.3v-3.6h-9.5
		                       			C533.9,530.3,532.9,531.4,532.9,532.7z M525.9,530.3c1.2,0,2.2,1,2.2,2.2v38.3c0,1.2-1,2.2-2.2,2.2h-12.4c-1.2,0-2.2-1-2.2-2.2
		                       			v-38.3c0-1.2,1-2.2,2.2-2.2H525.9z M524.5,533.9h-9.6v35.5h9.6V533.9z M592,542.6l-39.4,56.3h-8.9l15.2-37.6H530l40.7-56.3h9.2
		                       			l-16.6,37.6H592z M585.1,546.2h-27.4l16.6-37.6h-1.8L537,557.7h27.2L549,595.3h1.7L585.1,546.2z M628.3,539.1v25.6
		                       			c0,1.4-1.1,2.5-2.5,2.5h-6.7v11.4c0,2.6-2.1,4.8-4.8,4.8h-43v-3.6h43c0.6,0,1.2-0.5,1.2-1.2v-11.4l0,0v-30.6l0,0v-11.4
		                       			c0-0.6-0.5-1.2-1.2-1.2h-36.8v-3.6h36.8c2.6,0,4.8,2.1,4.8,4.8v11.4h6.7C627.2,536.6,628.3,537.8,628.3,539.1z M624.7,540.2h-5.6
		                       			v23.4h5.6V540.2z M596.6,573c-1.2,0-2.2-1-2.2-2.2v-38.3c0-1.2,1-2.2,2.2-2.2H609c1.2,0,2.2,1,2.2,2.2v38.3c0,1.2-1,2.2-2.2,2.2
		                       			H596.6z M598,569.4h9.6v-35.5H598V569.4z M589.6,538.8v-6.1c0-1.3-1.1-2.4-2.4-2.4h-12c-1.3,0-2.4,1.1-2.4,2.4v6.1h3.6v-4.9h9.6
		                       			v4.9H589.6z M577.6,569.4v3.6h9.6c1.3,0,2.4-1.1,2.4-2.4v-13.2H586v12L577.6,569.4L577.6,569.4z"/>
		                       	</g>
		                    </g>

							<g className="z10 citem-144" onClick={() => {handleClickSummer(1)}} ref={(element) => {summerItems.current[1] = element}}>
								<g className="text">
									<g>
										<path className="st2" d="M990,737.1H838.9l-18.2-31.6l-18.2,31.6H651.3c-13,0-23.5,10.5-23.5,23.5v171.1c0,13,10.5,23.5,23.5,23.5
											H990c13,0,23.5-10.5,23.5-23.5V760.6C1013.5,747.6,1003,737.1,990,737.1z"/>
										<path className="st10" d="M990,956.2H651.3c-13.5,0-24.5-11-24.5-24.5V760.6c0-13.5,11-24.5,24.5-24.5h150.6l18.8-32.6l18.8,32.6H990
											c13.5,0,24.5,11,24.5,24.5v171.1C1014.5,945.2,1003.5,956.2,990,956.2z M651.3,738.1c-12.4,0-22.5,10.1-22.5,22.5v171.1
											c0,12.4,10.1,22.5,22.5,22.5H990c12.4,0,22.5-10.1,22.5-22.5V760.6c0-12.4-10.1-22.5-22.5-22.5H838.3l-17.7-30.6L803,738.1H651.3
											z"/>
									</g>
									<rect x="650.8" y="774.5" className="st3" width="339.6" height="159.3"/>
									<text transform="matrix(1 0 0 1 674.3088 792.532)" className="st10 st4 st11">In 2020, COVID-related </text>
									<text transform="matrix(1 0 0 1 704.3088 824.932)" className="st10 st4 st11">impacts decreased </text>
									<text transform="matrix(1 0 0 1 653.9088 857.332)" className="st10 st4 st11">summer demand, resulting </text>
									<text transform="matrix(1 0 0 1 656.2088 889.732)" className="st10 st4 st11">in a peak of approximately </text>
									<text transform="matrix(1 0 0 1 737.5088 922.132)" className="st9 st4 st11">144,000 MW.</text>
								</g>
								<g className="summer-circle-item icon-4">
									<linearGradient id="SVGID_00000173132802370274373150000002801081904873476011_" gradientUnits="userSpaceOnUse" x1="764.7697" y1="302.0636" x2="913.6453" y2="485.0328" gradientTransform="matrix(1 0 0 1 0 188)">
										<stop  offset="0" style={{stopColor:"#42C3E4"}}/>
										<stop  offset="0.1714" style={{stopColor:"#42C3E4"}}/>
										<stop  offset="0.2633" style={{stopColor:"#44C3DE"}}/>
										<stop  offset="0.3836" style={{stopColor:"#49C2CE"}}/>
										<stop  offset="0.5195" style={{stopColor:"#51C2B3"}}/>
										<stop  offset="0.6669" style={{stopColor:"#5DC08D"}}/>
										<stop  offset="0.8236" style={{stopColor:"#6BBF5D"}}/>
										<stop  offset="0.9859" style={{stopColor:"#7DBD22"}}/>
										<stop  offset="1" style={{stopColor:"#7FBD1D"}}/>
									</linearGradient>
									<circle className="summer-circle" style={{fill:"url(#SVGID_00000173132802370274373150000002801081904873476011_)"}} cx="822" cy="560.4" r="112.5"/>
									<rect x="765.1" y="606.4" className="st3" width="113.8" height="51.6"/>
									<g className="icon-text">
										<text transform="matrix(1 0 0 1 770.4902 624.3596)" className="st10 st4 st11">144,000 </text>
										<text transform="matrix(1 0 0 1 797.5901 651.3596)" className="st10 st4 st11">MW</text>
									</g>
									<g className="rings">
										<path id="Stroke-1_00000057850190563870346370000018042596849283959966_" className="st13" d="M822.5,424.4
											c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4s131.4-58.8,131.4-131.4S895.1,424.4,822.5,424.4z M822.5,428.1
											c70.5,0,127.7,57.2,127.7,127.7S893,683.5,822.5,683.5s-127.7-57.2-127.7-127.7S752,428.1,822.5,428.1z"/>
										<path id="Stroke-3_00000118366130947826790240000013979266032389271224_" className="st14" d="M822.5,433.6
										c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4S953.9,637.6,953.9,565S895.1,433.6,822.5,433.6z M822.5,437.3
										c70.5,0,127.7,57.2,127.7,127.7S893,692.7,822.5,692.7S694.8,635.5,694.8,565S752,437.3,822.5,437.3z"/>
									</g>
									<path className="center-icon st10" d="M872.2,526.5c2,0,3.8-0.8,5.2-2.2c1.4-1.4,2.2-3.2,2.2-5.2s-0.8-3.8-2.2-5.2c-1.2-1.2-2.7-1.9-4.4-2.1
										c-0.1-3.4-1.4-6.6-3.8-9c-2.5-2.5-5.8-3.8-9.3-3.8l0,0c-6.5,0-11.8,4.6-12.9,10.7c-0.2,0-0.4,0-0.5,0l0,0c-2.6,0-5,1.2-6.5,3.2
										l-5.2-7.7L811.7,543l-10.4-15.4l-5.1,7.5c-0.6-2-1.7-3.9-3.2-5.4c-2.5-2.5-5.8-3.8-9.3-3.8l0,0c-6.5,0-11.8,4.6-12.9,10.7
										c-3.5-0.3-6.7,1.7-8.2,4.9c-0.5,1.1-0.8,2.3-0.8,3.5c0,2.2,0.9,4.4,2.5,6c1.6,1.6,3.7,2.5,6,2.5h13.5l-21.6,32l2.8,1.9l23.8-35.2
										l7.2,7.2l5.2-6.4l5.2,6.5l7.2-7.2l24,35.5l2.8-1.9l-26.8-39.5l8.9-14.6l6.9,6.9l5.2-6.4l5.2,6.5l7.8-7.8l23.8,35.1l2.8-1.9
										L849,527L872.2,526.5L872.2,526.5z M770.1,549.8c-1.3,0-2.6-0.5-3.5-1.5c-0.9-0.9-1.5-2.2-1.5-3.5c0-0.7,0.2-1.4,0.5-2.1
										c0.8-1.8,2.6-2.9,4.5-2.9c0.5,0,0.9,0.1,1.5,0.3l2.2,0.7l0.1-2.3c0.1-5.3,4.4-9.4,9.7-9.4l0,0c2.6,0,5,1,6.8,2.8
										c1.8,1.8,2.8,4.3,2.8,6.8c0,0.1,0,0.2,0,0.4l-7.2,10.7H770.1z M806.7,554.1l-5.5-6.8l-5.5,6.8l-4.8-4.8l-1,1l6.6-9.7h0.1
										c0-0.1,0-0.1,0-0.2l4.6-6.8l10.5,15.5L806.7,554.1z M845.7,527.8l-5.4,5.4l-5.5-6.8l-5.5,6.8l-4.8-4.8l0,0l10.4-17l11.5,17
										L845.7,527.8z M842,515.9c0.8-1.7,2.6-2.8,4.5-2.8l0,0c0.5,0,1,0.1,1.5,0.3l2.2,0.7l0.1-2.3c0.1-5.3,4.4-9.4,9.7-9.4l0,0
										c2.6,0,5,1,6.8,2.8c1.8,1.8,2.8,4.3,2.8,6.8c0,0.4,0,0.9-0.1,1.3l-0.3,2.3l2.3-0.4c0.2,0,0.4-0.1,0.7-0.1c2.2,0,4,1.8,4,4
										c0,1.1-0.4,2.1-1.2,2.8c-0.7,0.7-1.7,1.2-2.8,1.2l0,0h-25.3L842,515.9z"/>
									{/*<path className="center-icon st10" d="M821.4,611.8c-2,0-4.1-0.4-5.7-1.1c-1.6-0.7-2.8-2.1-3.3-3.8c-0.5-1.8-0.1-3.8,1-5.3
										c1.2-1.7,2.2-3.1,2.6-4.5c0.2-0.6,0.1-1.2-0.2-1.8c-0.4-0.6-1-1-1.7-1.2c-1.6-0.3-3.2-0.8-4.8-1.3c-0.8-0.3-1.6-0.2-2.3,0.3
										c-0.3,0.2-0.9,0.8-1,1.7c0,0.7,0,1.4,0.1,2.6c0.1,1.5-0.4,3-1.5,4.1c-1,1-2.4,1.5-3.8,1.4c-2.8-0.3-5.9-2.1-7.5-4.3
										c-0.8-1.1-1.1-2.6-0.7-4c0.4-1.5,1.4-2.7,2.8-3.4c0.7-0.3,1.3-0.6,1.9-1c0.7-0.4,1.1-1.1,1.2-1.9c0.1-0.8-0.3-1.6-0.9-2.2
										c-1.6-1.3-3.1-2.8-4.5-4.4c-0.5-0.6-1.2-0.9-1.9-0.9s-1.2,0.2-1.7,0.7c-1,1.1-1.8,2.6-2.6,4.5c-0.8,1.7-2.3,3-4.1,3.5
										c-1.7,0.5-3.6,0.1-5-0.9c-3-2.2-5.3-6.3-5.7-10c-0.2-1.7,0.4-3.5,1.7-4.8s3.2-2,5.1-1.8c2.1,0.2,3.8,0.3,5.2,0
										c0.6-0.1,1.1-0.5,1.4-1.1c0.4-0.6,0.4-1.4,0.2-2.1c-0.5-1.6-1-3.2-1.3-4.8c-0.2-0.8-0.7-1.5-1.5-1.9c-0.4-0.2-1.2-0.4-2.1,0.1
										c-0.5,0.3-1.1,0.7-1.7,1.1c-1.2,0.9-2.9,1.2-4.3,0.7c-1.4-0.4-2.5-1.3-3.1-2.6c-1.1-2.5-1.1-6.1,0-8.7c0.6-1.3,1.7-2.2,3.1-2.6
										c1.5-0.4,3.1-0.1,4.3,0.7c0.5,0.3,0.9,0.6,1.3,0.9c0.7,0.4,1.5,0.5,2.3,0.2s1.3-1,1.4-1.9c0.3-1.9,0.8-3.8,1.4-5.6
										c0.2-0.7,0.2-1.5-0.2-2.1c-0.3-0.6-0.8-1-1.4-1.1c-1.4-0.3-3.1-0.2-5.2,0c-1.9,0.2-3.8-0.5-5.1-1.8s-1.9-3-1.7-4.8
										c0.4-3.7,2.8-7.8,5.8-10c1.4-1,3.2-1.4,5-0.9s3.4,1.8,4.1,3.5c0.9,1.9,1.6,3.4,2.6,4.5c0.4,0.5,1,0.8,1.7,0.7
										c0.7,0,1.4-0.3,1.9-0.9c1.2-1.4,2.5-2.6,3.8-3.8c0.7-0.6,1-1.4,0.9-2.2c0-0.4-0.2-1.2-1.1-1.7c-0.5-0.3-1.1-0.6-1.7-0.9
										c-1.4-0.6-2.4-1.9-2.8-3.4c-0.4-1.4-0.1-2.9,0.7-4c1.6-2.3,4.7-4,7.5-4.3c1.4-0.2,2.8,0.3,3.8,1.4c1.1,1.1,1.7,2.6,1.5,4.1
										c-0.1,0.7-0.1,1.3-0.1,1.9c0,1,0.6,1.6,1,1.9c0.7,0.5,1.6,0.6,2.4,0.3c1.7-0.6,3.5-1.1,5.2-1.4c0.7-0.1,1.4-0.6,1.7-1.2
										c0.3-0.6,0.4-1.2,0.2-1.8c-0.4-1.4-1.4-2.8-2.6-4.5c-1.1-1.5-1.5-3.5-1-5.3c0.5-1.7,1.7-3.1,3.3-3.8c3.4-1.5,8.1-1.5,11.5,0
										c1.6,0.7,2.8,2.1,3.3,3.8c0.5,1.8,0.1,3.8-1,5.3c-1.2,1.7-2.1,3.1-2.6,4.5c-0.2,0.6-0.1,1.2,0.2,1.8c0.4,0.6,1,1.1,1.7,1.2
										c1.7,0.4,3.5,0.8,5.2,1.4c1.1,0.4,2-0.2,2.3-0.4c0.7-0.6,1-1.4,0.9-2.2c-0.1-0.3-0.1-0.7-0.2-1.1c-0.3-1.6,0.2-3.1,1.3-4.2
										c1.1-1.1,2.7-1.6,4.3-1.3c3.1,0.5,6.6,2.6,8.6,4.9c1.1,1.3,1.4,2.9,1,4.4s-1.5,2.7-3,3.2c-0.5,0.2-1,0.4-1.4,0.5
										c-0.8,0.3-1.3,1-1.4,1.8c-0.1,0.8,0.1,1.7,0.8,2.2c1,0.9,2,1.9,2.9,3c0.5,0.5,1.1,0.8,1.8,0.8l0,0c0.6,0,1.2-0.2,1.6-0.7
										c1-1.1,1.8-2.6,2.7-4.5c0.8-1.7,2.3-3,4.1-3.5c1.7-0.5,3.6-0.1,5,0.9c3,2.2,5.3,6.3,5.7,10c0.2,1.7-0.4,3.5-1.7,4.8
										s-3.2,2-5.1,1.8c-2.1-0.2-3.8-0.3-5.2,0c-0.6,0.1-1.1,0.5-1.4,1.1c-0.3,0.6-0.4,1.4-0.2,2c0.6,1.7,1,3.4,1.4,5.2
										c0.2,0.9,0.7,1.6,1.5,1.9c0.8,0.3,1.6,0.2,2.3-0.3c0.4-0.3,0.8-0.7,1.3-1.1c1.2-1,2.8-1.4,4.3-1s2.7,1.5,3.3,3.1
										c1.1,2.9,1.1,7,0,9.9c-0.6,1.6-1.8,2.7-3.3,3.1c-1.5,0.4-3,0-4.3-1l0,0c-0.6-0.5-1.1-0.9-1.6-1.3c-0.6-0.4-1.4-0.5-2.1-0.2
										c-0.8,0.3-1.3,1-1.5,1.8c-0.3,1.5-0.7,3-1.2,4.5c-0.2,0.7-0.2,1.4,0.2,2c0.3,0.6,0.8,1,1.4,1.1c1.4,0.3,3.1,0.2,5.2,0
										c1.9-0.2,3.8,0.5,5.1,1.8s1.9,3,1.7,4.8c-0.4,3.7-2.8,7.8-5.8,10c-1.4,1-3.2,1.4-5,0.9s-3.4-1.8-4.1-3.5c-0.9-2-1.7-3.5-2.6-4.5
										c-0.4-0.4-1-0.7-1.6-0.7l0,0c-0.7,0-1.4,0.3-1.9,0.9c-1.1,1.2-2.2,2.4-3.5,3.5c-0.7,0.6-1,1.5-0.9,2.3c0.1,0.4,0.3,1.3,1.3,1.7
										c0.5,0.2,1.1,0.5,1.8,0.7c1.5,0.5,2.6,1.7,3,3.2s0,3.1-1,4.4c-2,2.4-5.5,4.4-8.6,4.9c-1.6,0.3-3.2-0.2-4.3-1.3s-1.5-2.6-1.3-4.2
										c0.1-0.7,0.2-1.3,0.3-1.9c0.1-1-0.5-1.7-0.8-1.9c-0.7-0.5-1.6-0.7-2.4-0.4c-1.5,0.5-3.1,1-4.7,1.3c-0.7,0.1-1.3,0.6-1.7,1.2
										c-0.3,0.5-0.4,1.2-0.2,1.8c0.4,1.4,1.4,2.8,2.6,4.5c1.1,1.5,1.5,3.5,1,5.3c-0.5,1.7-1.7,3.1-3.3,3.8
										C825.5,611.5,823.5,611.8,821.4,611.8z M808.4,589c0.7,0,1.4,0.1,2,0.3c1.4,0.5,2.9,0.9,4.4,1.2c1.7,0.3,3.2,1.4,4.1,2.9
										c0.9,1.4,1,3.1,0.6,4.7c-0.6,1.8-1.7,3.6-3.1,5.6c-0.5,0.6-0.6,1.5-0.4,2.3c0.1,0.4,0.4,1.1,1.2,1.5c2.5,1.1,6.2,1.1,8.6,0
										c0.8-0.4,1.1-1.1,1.2-1.5c0.2-0.8,0.1-1.6-0.4-2.3c-1.5-2-2.5-3.7-3.1-5.6c-0.5-1.6-0.3-3.2,0.6-4.7c0.9-1.5,2.4-2.5,4.1-2.9
										c1.4-0.3,2.9-0.7,4.3-1.2c2-0.7,4.2-0.3,5.9,1c1.6,1.2,2.4,3.2,2.2,5.1c-0.1,0.7-0.2,1.4-0.3,2.1c-0.1,0.4,0,0.8,0.3,1
										c0.3,0.3,0.7,0.4,1.2,0.3c2.2-0.4,5-2,6.4-3.7c0.3-0.4,0.4-0.8,0.3-1.2c-0.1-0.3-0.4-0.6-0.7-0.7c-0.7-0.3-1.4-0.5-2-0.8
										c-1.8-0.8-3.1-2.5-3.4-4.4c-0.3-2.1,0.4-4.1,2-5.5c1.1-1,2.2-2,3.1-3.2c1.1-1.3,2.8-2.1,4.5-2.1h0.1c1.6,0,3.1,0.7,4.3,1.8
										c1.3,1.4,2.3,3.2,3.3,5.5c0.3,0.7,1,1.3,1.8,1.5c0.4,0.1,1.2,0.2,1.9-0.3c2.2-1.6,4-4.8,4.3-7.5c0.1-0.9-0.4-1.5-0.7-1.8
										c-0.6-0.6-1.4-0.9-2.2-0.8c-2.5,0.3-4.5,0.3-6.4-0.1c-1.6-0.4-3-1.4-3.8-2.8c-0.8-1.5-1-3.3-0.4-4.9c0.5-1.3,0.8-2.7,1.1-4.1
										c0.4-2,1.8-3.7,3.7-4.4c1.8-0.7,3.9-0.5,5.5,0.7c0.6,0.4,1.2,0.9,1.8,1.5l0,0c0.3,0.3,0.7,0.4,1,0.3c0.4-0.1,0.7-0.4,0.9-0.9
										c0.8-2.1,0.8-5.3,0-7.4c-0.2-0.5-0.5-0.8-0.9-0.9c-0.4-0.1-0.7,0-1,0.3c-0.5,0.4-1,0.8-1.5,1.2c-1.7,1.2-3.8,1.5-5.7,0.8
										c-2-0.8-3.4-2.5-3.8-4.6c-0.3-1.6-0.7-3.2-1.2-4.7c-0.6-1.6-0.4-3.5,0.4-5c0.8-1.5,2.2-2.5,3.8-2.8c1.9-0.4,3.9-0.3,6.4-0.1
										c0.8,0.1,1.6-0.2,2.2-0.8c0.3-0.3,0.8-0.9,0.7-1.8c-0.3-2.7-2.2-5.9-4.3-7.5c-0.7-0.5-1.5-0.4-1.9-0.3c-0.8,0.2-1.4,0.8-1.8,1.5
										c-1,2.3-2,4.1-3.3,5.5c-1.1,1.2-2.6,1.8-4.3,1.8h-0.1c-1.7,0-3.3-0.8-4.5-2.1c-0.8-0.9-1.7-1.8-2.6-2.7c-1.5-1.4-2.2-3.5-1.9-5.5
										s1.7-3.7,3.6-4.5c0.5-0.2,1-0.4,1.6-0.6c0.4-0.1,0.6-0.4,0.7-0.7c0.1-0.4,0-0.8-0.3-1.2c-1.4-1.7-4.2-3.3-6.4-3.7
										c-0.5-0.1-0.9,0-1.2,0.3s-0.4,0.6-0.3,1c0.1,0.4,0.1,0.8,0.2,1.2c0.3,2.1-0.5,4.2-2.1,5.5s-3.8,1.7-5.8,1c-1.5-0.5-3.1-1-4.7-1.3
										c-1.7-0.3-3.2-1.4-4.1-2.9c-0.9-1.5-1-3.1-0.5-4.7c0.6-1.8,1.7-3.5,3.1-5.5c0.5-0.6,0.6-1.5,0.4-2.3c-0.1-0.4-0.4-1.1-1.2-1.5
										c-2.5-1.1-6.2-1.1-8.6,0c-0.8,0.4-1.1,1.1-1.2,1.5c-0.2,0.8-0.1,1.6,0.4,2.3c1.4,2,2.5,3.7,3.1,5.5c0.5,1.6,0.3,3.3-0.5,4.7
										c-0.9,1.5-2.4,2.6-4.1,2.9c-1.6,0.3-3.2,0.8-4.7,1.3c-1.9,0.7-4.1,0.4-5.7-0.8c-1.6-1.1-2.5-2.9-2.5-4.9c0-0.7,0.1-1.4,0.1-2.2
										c0-0.4-0.1-0.9-0.5-1.2c-0.2-0.2-0.5-0.4-0.9-0.4c-1.7,0.2-3.9,1.4-5,2.9c-0.3,0.3-0.2,0.7-0.1,1c0.1,0.4,0.4,0.8,0.8,1
										c0.7,0.3,1.4,0.7,2,1c1.7,1,2.7,2.6,2.9,4.5c0.2,2-0.6,4-2.2,5.3c-1.2,1.1-2.4,2.2-3.5,3.5c-1.2,1.3-2.8,2.1-4.6,2.1
										c0,0,0,0-0.1,0c-1.7,0-3.2-0.7-4.3-1.9c-1.3-1.4-2.2-3.2-3.2-5.5c-0.3-0.7-1-1.3-1.8-1.5c-0.4-0.1-1.2-0.2-1.9,0.3
										c-2.2,1.6-4,4.8-4.3,7.5c-0.1,0.9,0.4,1.5,0.7,1.8c0.6,0.6,1.4,0.9,2.2,0.8c2.4-0.3,4.5-0.3,6.3,0.1c1.6,0.4,3,1.4,3.8,2.8
										c0.9,1.5,1,3.3,0.5,5c-0.6,1.6-1,3.4-1.3,5.1c-0.4,2-1.7,3.7-3.5,4.6c-1.8,0.8-3.9,0.7-5.6-0.4c-0.5-0.3-1-0.6-1.5-1
										c-0.4-0.3-0.8-0.3-1.3-0.2c-0.2,0.1-0.6,0.2-0.8,0.6c-0.7,1.6-0.7,4.1,0,5.7c0.2,0.4,0.5,0.5,0.8,0.6c0.4,0.1,0.9,0,1.3-0.2
										c0.7-0.5,1.3-0.9,1.9-1.3c1.7-0.9,3.6-1,5.3-0.2c1.8,0.8,3.1,2.5,3.5,4.5c0.3,1.5,0.7,2.9,1.2,4.3c0.6,1.7,0.4,3.5-0.5,5.1
										c-0.8,1.5-2.2,2.5-3.8,2.8c-1.9,0.4-3.9,0.3-6.3,0.1c-0.8-0.1-1.6,0.2-2.2,0.8c-0.3,0.3-0.8,0.9-0.7,1.8c0.3,2.7,2.2,5.9,4.3,7.5
										c0.7,0.5,1.5,0.4,1.9,0.3c0.8-0.2,1.4-0.8,1.8-1.5c1-2.2,1.9-4,3.3-5.5c1.1-1.2,2.6-1.9,4.3-1.9c0,0,0,0,0.1,0
										c1.7,0,3.4,0.8,4.6,2.1c1.3,1.4,2.6,2.8,4.1,4c1.6,1.3,2.4,3.2,2.2,5.2s-1.2,3.7-2.9,4.7c-0.6,0.3-1.3,0.7-2.2,1.1
										c-0.4,0.2-0.7,0.6-0.8,1c-0.1,0.2-0.1,0.6,0.1,0.9c1,1.4,3.2,2.7,5,2.9c0.4,0,0.7-0.2,0.9-0.4c0.3-0.3,0.5-0.8,0.5-1.2
										c-0.1-1.4-0.2-2.3-0.1-3.1c0.1-1.8,1-3.5,2.6-4.5C806,589.4,807.2,589,808.4,589z M810.9,543.7c-3.3,0-6.1-2.7-6.1-6.1
										s2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1S814.2,543.7,810.9,543.7z M810.9,535.2c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5
										S812.2,535.2,810.9,535.2z M821.5,582c-2.2,0-3.9-1.8-3.9-3.9s1.8-3.9,3.9-3.9c2.2,0,3.9,1.8,3.9,3.9S823.7,582,821.5,582z
										 M821.5,577.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.4,0.7,0.4,0.7,0C821.8,577.9,821.7,577.8,821.5,577.8z M840.6,573.5
										c-3.3,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1S844,573.5,840.6,573.5z M840.6,565c-1.4,0-2.5,1.1-2.5,2.5
										s1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5S842,565,840.6,565z M806.6,573.5c-5.7,0-10.3-4.6-10.3-10.3s4.6-10.3,10.3-10.3
										s10.3,4.6,10.3,10.3S812.3,573.5,806.6,573.5z M806.6,556.5c-3.7,0-6.7,3-6.7,6.7s3,6.7,6.7,6.7s6.7-3,6.7-6.7
										S810.3,556.5,806.6,556.5z M834.3,552.2c-4.5,0-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2s8.2,3.7,8.2,8.2
										C842.4,548.6,838.8,552.2,834.3,552.2z M834.3,539.5c-2.5,0-4.6,2.1-4.6,4.6s2.1,4.6,4.6,4.6s4.6-2.1,4.6-4.6
										C838.8,541.5,836.8,539.5,834.3,539.5z M821.4,611.8c-2,0-4.1-0.4-5.7-1.1c-1.6-0.7-2.8-2.1-3.3-3.8c-0.5-1.8-0.1-3.8,1-5.3
										c1.2-1.7,2.2-3.1,2.6-4.5c0.2-0.6,0.1-1.2-0.2-1.8c-0.4-0.6-1-1-1.7-1.2c-1.6-0.3-3.2-0.8-4.8-1.3c-0.8-0.3-1.6-0.2-2.3,0.3
										c-0.3,0.2-0.9,0.8-1,1.7c0,0.7,0,1.4,0.1,2.6c0.1,1.5-0.4,3-1.5,4.1c-1,1-2.4,1.5-3.8,1.4c-2.8-0.3-5.9-2.1-7.5-4.3
										c-0.8-1.1-1.1-2.6-0.7-4c0.4-1.5,1.4-2.7,2.8-3.4c0.7-0.3,1.3-0.6,1.9-1c0.7-0.4,1.1-1.1,1.2-1.9c0.1-0.8-0.3-1.6-0.9-2.2
										c-1.6-1.3-3.1-2.8-4.5-4.4c-0.5-0.6-1.2-0.9-1.9-0.9s-1.2,0.2-1.7,0.7c-1,1.1-1.8,2.6-2.6,4.5c-0.8,1.7-2.3,3-4.1,3.5
										c-1.7,0.5-3.6,0.1-5-0.9c-3-2.2-5.3-6.3-5.7-10c-0.2-1.7,0.4-3.5,1.7-4.8s3.2-2,5.1-1.8c2.1,0.2,3.8,0.3,5.2,0
										c0.6-0.1,1.1-0.5,1.4-1.1c0.4-0.6,0.4-1.4,0.2-2.1c-0.5-1.6-1-3.2-1.3-4.8c-0.2-0.8-0.7-1.5-1.5-1.9c-0.4-0.2-1.2-0.4-2.1,0.1
										c-0.5,0.3-1.1,0.7-1.7,1.1c-1.2,0.9-2.9,1.2-4.3,0.7c-1.4-0.4-2.5-1.3-3.1-2.6c-1.1-2.5-1.1-6.1,0-8.7c0.6-1.3,1.7-2.2,3.1-2.6
										c1.5-0.4,3.1-0.1,4.3,0.7c0.5,0.3,0.9,0.6,1.3,0.9c0.7,0.4,1.5,0.5,2.3,0.2s1.3-1,1.4-1.9c0.3-1.9,0.8-3.8,1.4-5.6
										c0.2-0.7,0.2-1.5-0.2-2.1c-0.3-0.6-0.8-1-1.4-1.1c-1.4-0.3-3.1-0.2-5.2,0c-1.9,0.2-3.8-0.5-5.1-1.8s-1.9-3-1.7-4.8
										c0.4-3.7,2.8-7.8,5.8-10c1.4-1,3.2-1.4,5-0.9s3.4,1.8,4.1,3.5c0.9,1.9,1.6,3.4,2.6,4.5c0.4,0.5,1,0.8,1.7,0.7
										c0.7,0,1.4-0.3,1.9-0.9c1.2-1.4,2.5-2.6,3.8-3.8c0.7-0.6,1-1.4,0.9-2.2c0-0.4-0.2-1.2-1.1-1.7c-0.5-0.3-1.1-0.6-1.7-0.9
										c-1.4-0.6-2.4-1.9-2.8-3.4c-0.4-1.4-0.1-2.9,0.7-4c1.6-2.3,4.7-4,7.5-4.3c1.4-0.2,2.8,0.3,3.8,1.4c1.1,1.1,1.7,2.6,1.5,4.1
										c-0.1,0.7-0.1,1.3-0.1,1.9c0,1,0.6,1.6,1,1.9c0.7,0.5,1.6,0.6,2.4,0.3c1.7-0.6,3.5-1.1,5.2-1.4c0.7-0.1,1.4-0.6,1.7-1.2
										c0.3-0.6,0.4-1.2,0.2-1.8c-0.4-1.4-1.4-2.8-2.6-4.5c-1.1-1.5-1.5-3.5-1-5.3c0.5-1.7,1.7-3.1,3.3-3.8c3.4-1.5,8.1-1.5,11.5,0
										c1.6,0.7,2.8,2.1,3.3,3.8c0.5,1.8,0.1,3.8-1,5.3c-1.2,1.7-2.1,3.1-2.6,4.5c-0.2,0.6-0.1,1.2,0.2,1.8c0.4,0.6,1,1.1,1.7,1.2
										c1.7,0.4,3.5,0.8,5.2,1.4c1.1,0.4,2-0.2,2.3-0.4c0.7-0.6,1-1.4,0.9-2.2c-0.1-0.3-0.1-0.7-0.2-1.1c-0.3-1.6,0.2-3.1,1.3-4.2
										c1.1-1.1,2.7-1.6,4.3-1.3c3.1,0.5,6.6,2.6,8.6,4.9c1.1,1.3,1.4,2.9,1,4.4s-1.5,2.7-3,3.2c-0.5,0.2-1,0.4-1.4,0.5
										c-0.8,0.3-1.3,1-1.4,1.8c-0.1,0.8,0.1,1.7,0.8,2.2c1,0.9,2,1.9,2.9,3c0.5,0.5,1.1,0.8,1.8,0.8l0,0c0.6,0,1.2-0.2,1.6-0.7
										c1-1.1,1.8-2.6,2.7-4.5c0.8-1.7,2.3-3,4.1-3.5c1.7-0.5,3.6-0.1,5,0.9c3,2.2,5.3,6.3,5.7,10c0.2,1.7-0.4,3.5-1.7,4.8
										s-3.2,2-5.1,1.8c-2.1-0.2-3.8-0.3-5.2,0c-0.6,0.1-1.1,0.5-1.4,1.1c-0.3,0.6-0.4,1.4-0.2,2c0.6,1.7,1,3.4,1.4,5.2
										c0.2,0.9,0.7,1.6,1.5,1.9c0.8,0.3,1.6,0.2,2.3-0.3c0.4-0.3,0.8-0.7,1.3-1.1c1.2-1,2.8-1.4,4.3-1s2.7,1.5,3.3,3.1
										c1.1,2.9,1.1,7,0,9.9c-0.6,1.6-1.8,2.7-3.3,3.1c-1.5,0.4-3,0-4.3-1l0,0c-0.6-0.5-1.1-0.9-1.6-1.3c-0.6-0.4-1.4-0.5-2.1-0.2
										c-0.8,0.3-1.3,1-1.5,1.8c-0.3,1.5-0.7,3-1.2,4.5c-0.2,0.7-0.2,1.4,0.2,2c0.3,0.6,0.8,1,1.4,1.1c1.4,0.3,3.1,0.2,5.2,0
										c1.9-0.2,3.8,0.5,5.1,1.8s1.9,3,1.7,4.8c-0.4,3.7-2.8,7.8-5.8,10c-1.4,1-3.2,1.4-5,0.9s-3.4-1.8-4.1-3.5c-0.9-2-1.7-3.5-2.6-4.5
										c-0.4-0.4-1-0.7-1.6-0.7l0,0c-0.7,0-1.4,0.3-1.9,0.9c-1.1,1.2-2.2,2.4-3.5,3.5c-0.7,0.6-1,1.5-0.9,2.3c0.1,0.4,0.3,1.3,1.3,1.7
										c0.5,0.2,1.1,0.5,1.8,0.7c1.5,0.5,2.6,1.7,3,3.2s0,3.1-1,4.4c-2,2.4-5.5,4.4-8.6,4.9c-1.6,0.3-3.2-0.2-4.3-1.3s-1.5-2.6-1.3-4.2
										c0.1-0.7,0.2-1.3,0.3-1.9c0.1-1-0.5-1.7-0.8-1.9c-0.7-0.5-1.6-0.7-2.4-0.4c-1.5,0.5-3.1,1-4.7,1.3c-0.7,0.1-1.3,0.6-1.7,1.2
										c-0.3,0.5-0.4,1.2-0.2,1.8c0.4,1.4,1.4,2.8,2.6,4.5c1.1,1.5,1.5,3.5,1,5.3c-0.5,1.7-1.7,3.1-3.3,3.8
										C825.5,611.5,823.5,611.8,821.4,611.8z M808.4,589c0.7,0,1.4,0.1,2,0.3c1.4,0.5,2.9,0.9,4.4,1.2c1.7,0.3,3.2,1.4,4.1,2.9
										c0.9,1.4,1,3.1,0.6,4.7c-0.6,1.8-1.7,3.6-3.1,5.6c-0.5,0.6-0.6,1.5-0.4,2.3c0.1,0.4,0.4,1.1,1.2,1.5c2.5,1.1,6.2,1.1,8.6,0
										c0.8-0.4,1.1-1.1,1.2-1.5c0.2-0.8,0.1-1.6-0.4-2.3c-1.5-2-2.5-3.7-3.1-5.6c-0.5-1.6-0.3-3.2,0.6-4.7c0.9-1.5,2.4-2.5,4.1-2.9
										c1.4-0.3,2.9-0.7,4.3-1.2c2-0.7,4.2-0.3,5.9,1c1.6,1.2,2.4,3.2,2.2,5.1c-0.1,0.7-0.2,1.4-0.3,2.1c-0.1,0.4,0,0.8,0.3,1
										c0.3,0.3,0.7,0.4,1.2,0.3c2.2-0.4,5-2,6.4-3.7c0.3-0.4,0.4-0.8,0.3-1.2c-0.1-0.3-0.4-0.6-0.7-0.7c-0.7-0.3-1.4-0.5-2-0.8
										c-1.8-0.8-3.1-2.5-3.4-4.4c-0.3-2.1,0.4-4.1,2-5.5c1.1-1,2.2-2,3.1-3.2c1.1-1.3,2.8-2.1,4.5-2.1h0.1c1.6,0,3.1,0.7,4.3,1.8
										c1.3,1.4,2.3,3.2,3.3,5.5c0.3,0.7,1,1.3,1.8,1.5c0.4,0.1,1.2,0.2,1.9-0.3c2.2-1.6,4-4.8,4.3-7.5c0.1-0.9-0.4-1.5-0.7-1.8
										c-0.6-0.6-1.4-0.9-2.2-0.8c-2.5,0.3-4.5,0.3-6.4-0.1c-1.6-0.4-3-1.4-3.8-2.8c-0.8-1.5-1-3.3-0.4-4.9c0.5-1.3,0.8-2.7,1.1-4.1
										c0.4-2,1.8-3.7,3.7-4.4c1.8-0.7,3.9-0.5,5.5,0.7c0.6,0.4,1.2,0.9,1.8,1.5l0,0c0.3,0.3,0.7,0.4,1,0.3c0.4-0.1,0.7-0.4,0.9-0.9
										c0.8-2.1,0.8-5.3,0-7.4c-0.2-0.5-0.5-0.8-0.9-0.9c-0.4-0.1-0.7,0-1,0.3c-0.5,0.4-1,0.8-1.5,1.2c-1.7,1.2-3.8,1.5-5.7,0.8
										c-2-0.8-3.4-2.5-3.8-4.6c-0.3-1.6-0.7-3.2-1.2-4.7c-0.6-1.6-0.4-3.5,0.4-5c0.8-1.5,2.2-2.5,3.8-2.8c1.9-0.4,3.9-0.3,6.4-0.1
										c0.8,0.1,1.6-0.2,2.2-0.8c0.3-0.3,0.8-0.9,0.7-1.8c-0.3-2.7-2.2-5.9-4.3-7.5c-0.7-0.5-1.5-0.4-1.9-0.3c-0.8,0.2-1.4,0.8-1.8,1.5
										c-1,2.3-2,4.1-3.3,5.5c-1.1,1.2-2.6,1.8-4.3,1.8h-0.1c-1.7,0-3.3-0.8-4.5-2.1c-0.8-0.9-1.7-1.8-2.6-2.7c-1.5-1.4-2.2-3.5-1.9-5.5
										s1.7-3.7,3.6-4.5c0.5-0.2,1-0.4,1.6-0.6c0.4-0.1,0.6-0.4,0.7-0.7c0.1-0.4,0-0.8-0.3-1.2c-1.4-1.7-4.2-3.3-6.4-3.7
										c-0.5-0.1-0.9,0-1.2,0.3s-0.4,0.6-0.3,1c0.1,0.4,0.1,0.8,0.2,1.2c0.3,2.1-0.5,4.2-2.1,5.5s-3.8,1.7-5.8,1c-1.5-0.5-3.1-1-4.7-1.3
										c-1.7-0.3-3.2-1.4-4.1-2.9c-0.9-1.5-1-3.1-0.5-4.7c0.6-1.8,1.7-3.5,3.1-5.5c0.5-0.6,0.6-1.5,0.4-2.3c-0.1-0.4-0.4-1.1-1.2-1.5
										c-2.5-1.1-6.2-1.1-8.6,0c-0.8,0.4-1.1,1.1-1.2,1.5c-0.2,0.8-0.1,1.6,0.4,2.3c1.4,2,2.5,3.7,3.1,5.5c0.5,1.6,0.3,3.3-0.5,4.7
										c-0.9,1.5-2.4,2.6-4.1,2.9c-1.6,0.3-3.2,0.8-4.7,1.3c-1.9,0.7-4.1,0.4-5.7-0.8c-1.6-1.1-2.5-2.9-2.5-4.9c0-0.7,0.1-1.4,0.1-2.2
										c0-0.4-0.1-0.9-0.5-1.2c-0.2-0.2-0.5-0.4-0.9-0.4c-1.7,0.2-3.9,1.4-5,2.9c-0.3,0.3-0.2,0.7-0.1,1c0.1,0.4,0.4,0.8,0.8,1
										c0.7,0.3,1.4,0.7,2,1c1.7,1,2.7,2.6,2.9,4.5c0.2,2-0.6,4-2.2,5.3c-1.2,1.1-2.4,2.2-3.5,3.5c-1.2,1.3-2.8,2.1-4.6,2.1
										c0,0,0,0-0.1,0c-1.7,0-3.2-0.7-4.3-1.9c-1.3-1.4-2.2-3.2-3.2-5.5c-0.3-0.7-1-1.3-1.8-1.5c-0.4-0.1-1.2-0.2-1.9,0.3
										c-2.2,1.6-4,4.8-4.3,7.5c-0.1,0.9,0.4,1.5,0.7,1.8c0.6,0.6,1.4,0.9,2.2,0.8c2.4-0.3,4.5-0.3,6.3,0.1c1.6,0.4,3,1.4,3.8,2.8
										c0.9,1.5,1,3.3,0.5,5c-0.6,1.6-1,3.4-1.3,5.1c-0.4,2-1.7,3.7-3.5,4.6c-1.8,0.8-3.9,0.7-5.6-0.4c-0.5-0.3-1-0.6-1.5-1
										c-0.4-0.3-0.8-0.3-1.3-0.2c-0.2,0.1-0.6,0.2-0.8,0.6c-0.7,1.6-0.7,4.1,0,5.7c0.2,0.4,0.5,0.5,0.8,0.6c0.4,0.1,0.9,0,1.3-0.2
										c0.7-0.5,1.3-0.9,1.9-1.3c1.7-0.9,3.6-1,5.3-0.2c1.8,0.8,3.1,2.5,3.5,4.5c0.3,1.5,0.7,2.9,1.2,4.3c0.6,1.7,0.4,3.5-0.5,5.1
										c-0.8,1.5-2.2,2.5-3.8,2.8c-1.9,0.4-3.9,0.3-6.3,0.1c-0.8-0.1-1.6,0.2-2.2,0.8c-0.3,0.3-0.8,0.9-0.7,1.8c0.3,2.7,2.2,5.9,4.3,7.5
										c0.7,0.5,1.5,0.4,1.9,0.3c0.8-0.2,1.4-0.8,1.8-1.5c1-2.2,1.9-4,3.3-5.5c1.1-1.2,2.6-1.9,4.3-1.9c0,0,0,0,0.1,0
										c1.7,0,3.4,0.8,4.6,2.1c1.3,1.4,2.6,2.8,4.1,4c1.6,1.3,2.4,3.2,2.2,5.2s-1.2,3.7-2.9,4.7c-0.6,0.3-1.3,0.7-2.2,1.1
										c-0.4,0.2-0.7,0.6-0.8,1c-0.1,0.2-0.1,0.6,0.1,0.9c1,1.4,3.2,2.7,5,2.9c0.4,0,0.7-0.2,0.9-0.4c0.3-0.3,0.5-0.8,0.5-1.2
										c-0.1-1.4-0.2-2.3-0.1-3.1c0.1-1.8,1-3.5,2.6-4.5C806,589.4,807.2,589,808.4,589z M810.9,543.7c-3.3,0-6.1-2.7-6.1-6.1
										s2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1S814.2,543.7,810.9,543.7z M810.9,535.2c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5
										S812.2,535.2,810.9,535.2z M821.5,582c-2.2,0-3.9-1.8-3.9-3.9s1.8-3.9,3.9-3.9c2.2,0,3.9,1.8,3.9,3.9S823.7,582,821.5,582z
										 M821.5,577.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.4,0.7,0.4,0.7,0C821.8,577.9,821.7,577.8,821.5,577.8z M840.6,573.5
										c-3.3,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1S844,573.5,840.6,573.5z M840.6,565c-1.4,0-2.5,1.1-2.5,2.5
										s1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5S842,565,840.6,565z M806.6,573.5c-5.7,0-10.3-4.6-10.3-10.3s4.6-10.3,10.3-10.3
										s10.3,4.6,10.3,10.3S812.3,573.5,806.6,573.5z M806.6,556.5c-3.7,0-6.7,3-6.7,6.7s3,6.7,6.7,6.7s6.7-3,6.7-6.7
										S810.3,556.5,806.6,556.5z M834.3,552.2c-4.5,0-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2s8.2,3.7,8.2,8.2
										C842.4,548.6,838.8,552.2,834.3,552.2z M834.3,539.5c-2.5,0-4.6,2.1-4.6,4.6s2.1,4.6,4.6,4.6s4.6-2.1,4.6-4.6
										C838.8,541.5,836.8,539.5,834.3,539.5z"/>*/}
								</g>
							</g>

							<g className="z10 citem-800" onClick={() => {handleClickSummer(2)}} ref={(element) => {summerItems.current[2] = element}}>
								<g className="text">
									<g>
										<path className="st2" d="M476.7,642.1H345.6l-18.2-31.6l-18.2,31.6H178c-13,0-23.5,10.5-23.5,23.5v71c0,13,10.5,23.5,23.5,23.5h298.7
											c13,0,23.5-10.5,23.5-23.5v-71C500.3,652.6,489.7,642.1,476.7,642.1z"/>
										<path className="st10" d="M476.7,761.1H178c-13.5,0-24.5-11-24.5-24.5v-71c0-13.5,11-24.5,24.5-24.5h130.6l18.8-32.6l18.8,32.6h130.6
											c13.5,0,24.5,11,24.5,24.5v71C501.3,750.1,490.3,761.1,476.7,761.1z M178,643.1c-12.4,0-22.5,10.1-22.5,22.5v71
											c0,12.4,10.1,22.5,22.5,22.5h298.7c12.4,0,22.5-10.1,22.5-22.5v-71c0-12.4-10.1-22.5-22.5-22.5H345l-17.7-30.6l-17.7,30.6H178z"
											/>
									</g>
									<rect x="171.9" y="679.5" className="st3" width="311" height="68.2"/>
									<text transform="matrix(1 0 0 1 205.1011 697.5216)" className="st10 st4 st11">1 MW powers about  </text>
									<text transform="matrix(1 0 0 1 253.6011 729.9216)" className="st9 st4 st11">800 homes.</text>
								</g>
								<g className="summer-circle-item icon-2">
									<linearGradient id="SVGID_00000091737549176810705130000008117398172250036374_" gradientUnits="userSpaceOnUse" x1="271.8176" y1="207.9995" x2="450.1391" y2="427.1579" gradientTransform="matrix(1 0 0 1 0 188)">
										<stop  offset="0" style={{stopColor:"#FA0089"}}/>
										<stop  offset="1.000839e-02" style={{stopColor:"#F7038A"}}/>
										<stop  offset="0.2063" style={{stopColor:"#C13DA5"}}/>
										<stop  offset="0.3962" style={{stopColor:"#936DBC"}}/>
										<stop  offset="0.5751" style={{stopColor:"#7092CD"}}/>
										<stop  offset="0.7404" style={{stopColor:"#57ADDA"}}/>
										<stop  offset="0.887" style={{stopColor:"#47BDE1"}}/>
										<stop  offset="1" style={{stopColor:"#42C3E4"}}/>
									</linearGradient>
									<circle className="summer-circle" style={{fill:"url(#SVGID_00000091737549176810705130000008117398172250036374_)"}} cx="329.1" cy="466.4" r="112.5"/>
									<g className="rings">
										<path id="Stroke-1_00000107583160003135004770000007106018856192434366_" className="st13" d="M327.4,329.3
										c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4s131.4-58.8,131.4-131.4S400,329.3,327.4,329.3z M327.4,333
										c70.5,0,127.7,57.2,127.7,127.7s-57.2,127.7-127.7,127.7s-127.7-57.2-127.7-127.7S256.9,333,327.4,333z"/>
										<path id="Stroke-3_00000036233541165340577190000012373500087854978219_" className="st14" d="M327.4,338.5
										c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4s131.4-58.8,131.4-131.4S400,338.5,327.4,338.5z M327.4,342.2
										c70.5,0,127.7,57.2,127.7,127.7s-57.2,127.7-127.7,127.7s-127.7-57.2-127.7-127.7S256.9,342.2,327.4,342.2z"/>
									</g>
									<g className="center-icon">
										<path className="st10" d="M378,458.7v-2.9l-50.7-41.5l-19.6,16.1V425h-11.4v14.8l-19.7,16.1v2.9h12.6v41.7h-10.8v3.6h10.8h9.1h21.2
										h44.1h12.6v-3.6h-11.3v-11.9c0,0,0-0.5,0-1.3c1.1-0.1,2.1-0.5,3-1.1c1.5-1,2.6-2.5,3.3-4.5c0.6-1.6,0.5-3.9,0.4-5.6v-0.5
										c-0.2-4.1,0.4-5.8,1.7-9.1l1.5-4.1l-2.9,0.3c-4,0.4-7.9,2.1-11,4.6c-1.9,1.6-4.3,4.2-5.2,7.9c-0.9,3.5,0,7.2,2.3,9.6
										c1,1,2.2,1.7,3.4,2.1c0,1,0,1.6,0,1.7v11.9h-41.7v-34.2h-21.2v34.2H293v-43.1l34.5-28.4l36.2,29.8L378,458.7L378,458.7z
										M360.4,482.3c-1.4-1.5-2-3.9-1.4-6.2c0.7-2.7,2.6-4.7,4-5.9c1.8-1.5,3.9-2.6,6.1-3.2c-0.9,2.6-1.5,4.8-1.3,8.8v0.6
										c0.1,1.2,0.2,3.2-0.2,4.1c-0.3,0.9-0.9,2-1.9,2.7c-0.2,0.2-0.5,0.3-0.8,0.4c0.1-2.1,0.4-4.6,0.9-6.5l-3.5-0.9
										c-0.5,2.1-0.8,4.7-1,6.9C361.1,482.9,360.8,482.7,360.4,482.3z M301.9,469.9h14v30.6h-14V469.9z M300,428.6h4.2v4.9l-4.2,3.4
										V428.6z M289.9,455.1h-6.6l44.1-36.1l44.1,36.1h-6.6l-37.5-30.9L289.9,455.1z"/>
										<path className="st10" d="M327.1,466.3v17.5h-3.9v3.6h3.9h22.4h3.7v-3.6h-3.7v-17.5H327.1z M345.8,483.8h-15.2v-13.9h15.2V483.8z"/>
									</g>
									<rect x="272.1" y="488.8" className="st3" width="113.8" height="51.6"/>
									<g className="icon-text">
										<text transform="matrix(1 0 0 1 303.8112 506.7599)" className="st10 st4 st11">800 </text>
										<text transform="matrix(1 0 0 1 280.7112 533.7599)" className="st10 st4 st11">HOMES</text>
									</g>
								</g>
							</g>

							<g className="z10 citem-149" onClick={() => {handleClickSummer(3)}} ref={(element) => {summerItems.current[3] = element}}>
								<g className="text">
									<g>
										<path className="st2" d="M1219.2,632.3H1068l-18.2-31.6l-18.2,31.6H880.4c-13,0-23.5,10.5-23.5,23.5v111c0,13,10.5,23.5,23.5,23.5
											h338.8c13,0,23.5-10.5,23.5-23.5v-111C1242.7,642.8,1232.2,632.3,1219.2,632.3z"/>
										<path className="st10" d="M1219.2,791.3H880.4c-13.5,0-24.5-11-24.5-24.5v-111c0-13.5,11-24.5,24.5-24.5H1031l18.8-32.6l18.8,32.6
											h150.6c13.5,0,24.5,11,24.5,24.5v111C1243.7,780.3,1232.7,791.3,1219.2,791.3z M880.4,633.3c-12.4,0-22.5,10.1-22.5,22.5v111
											c0,12.4,10.1,22.5,22.5,22.5h338.8c12.4,0,22.5-10.1,22.5-22.5v-111c0-12.4-10.1-22.5-22.5-22.5h-151.7l-17.7-30.6l-17.7,30.6
											H880.4z"/>
									</g>
									<rect x="880" y="669.7" className="st3" width="339.6" height="101.4"/>
									<text transform="matrix(1 0 0 1 928.8638 687.7493)" className="st10 st4 st11">PJM forecasted the </text>
									<text transform="matrix(1 0 0 1 896.3638 720.1493)" className="st10 st4 st11">2021 summer peak to be </text>
									<text transform="matrix(1 0 0 1 927.1638 752.5493)" className="st10 st4 st11">about </text>
									<text transform="matrix(1 0 0 1 1006.1638 752.5493)" className="st9 st4 st11">149,000 MW.</text>
								</g>
								<g className="summer-circle-item icon-5">
									<rect x="996.4" y="489.5" className="st3" width="113.8" height="51.6"/>
									<g>
										<linearGradient id="SVGID_00000062172772195764644530000014737048463281592237_" gradientUnits="userSpaceOnUse" x1="1011.1719" y1="215.4241" x2="1202.6868" y2="450.7975" gradientTransform="matrix(1 0 0 1 0 188)">
											<stop  offset="0" style={{stopColor:"#FFC000"}}/>
											<stop  offset="0.1129" style={{stopColor:"#FEB906"}}/>
											<stop  offset="0.2803" style={{stopColor:"#FAA515"}}/>
											<stop  offset="0.4816" style={{stopColor:"#F5842E"}}/>
											<stop  offset="0.7093" style={{stopColor:"#ED5651"}}/>
											<stop  offset="0.9561" style={{stopColor:"#E41C7D"}}/>
											<stop  offset="1" style={{stopColor:"#E21185"}}/>
										</linearGradient>
										<ellipse className="summer-circle" style={{fill:"url(#SVGID_00000062172772195764644530000014737048463281592237_)"}} cx="1053.3" cy="455.2" rx="112.5" ry="110"/>
									</g>
									<g className="icon-text">
										<text transform="matrix(1 0 0 1 1001.7153 507.5356)" className="st10 st4 st11">149,000 </text>
										<text transform="matrix(1 0 0 1 1028.8153 534.5356)" className="st10 st4 st11">MW</text>
									</g>
									<path className="center-icon st10" d="M1031.1,494.3l-3.1-1.8l3.9-6.7l3.1,1.8L1031.1,494.3z M1079.3,410.7l-3.1-1.8l-3.9,6.7l3.1,1.8
										L1079.3,410.7z M1019.5,473.4l-1.8-3.1l-6.7,3.9l1.8,3.1L1019.5,473.4z M1096.3,429l-1.8-3.1l-6.7,3.9l1.8,3.1L1096.3,429z
										 M1013.1,449.8h-7.7v3.6h7.7V449.8z M1101.9,449.8h-7.7v3.6h7.7V449.8z M1019.5,429.8l-6.7-3.9l-1.8,3.1l6.7,3.9L1019.5,429.8z
										 M1096.3,474.2l-6.7-3.9l-1.8,3.1l6.7,3.9L1096.3,474.2z M1035,415.6l-3.9-6.7l-3.1,1.8l3.9,6.7L1035,415.6z M1079.3,492.5
										l-3.9-6.7l-3.1,1.8l3.9,6.7L1079.3,492.5z M1055.5,403.4h-3.6v7.7h3.6V403.4z M1055.5,492.1h-3.6v7.7h3.6V492.1z M1088.3,451.6
										c0-19.1-15.5-34.6-34.6-34.6s-34.6,15.5-34.6,34.6s15.5,34.6,34.6,34.6C1072.7,486.2,1088.3,470.7,1088.3,451.6z M1084.7,451.6
										c0,17.1-13.9,31-31,31s-31-13.9-31-31s13.9-31,31-31C1070.8,420.6,1084.7,434.5,1084.7,451.6z M1053.7,432.2v-3.6
										c-12.7,0-23,10.3-23,23h3.6C1034.2,440.9,1043,432.2,1053.7,432.2z"/>
									<g className="rings">
										<path id="Stroke-1_00000155145866223607278700000011658919721203797176_" className="st13" d="M1051.7,319.6
											c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4s131.4-58.8,131.4-131.4S1124.2,319.6,1051.7,319.6z M1051.7,323.3
											c70.5,0,127.7,57.2,127.7,127.7s-57.2,127.7-127.7,127.7C981.1,578.7,924,521.6,924,451S981.1,323.3,1051.7,323.3z"/>
										<path id="Stroke-3_00000019645284118450265850000004796732239270253745_" className="st14" d="M1051.7,328.8
											c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4s131.4-58.8,131.4-131.4S1124.2,328.8,1051.7,328.8z M1051.7,332.6
											c70.5,0,127.7,57.2,127.7,127.7S1122.2,588,1051.7,588C981.1,588,924,530.8,924,460.3S981.1,332.6,1051.7,332.6z"/>
									</g>
								</g>
							</g>

							<g className="z10 citem-185" onClick={() => {handleClickSummer(4)}} ref={(element) => {summerItems.current[4] = element}}>
							   	<g className="text">
							   		<g>
							   			<path className="st2" d="M323.1,417.7H192l-18.2-31.6l-18.2,31.6H24.4c-13,0-23.5,10.5-23.5,23.5v111c0,13,10.5,23.5,23.5,23.5h298.7
							   				c13,0,23.5-10.5,23.5-23.5v-111C346.6,428.3,336.1,417.7,323.1,417.7z"/>
							   			<path className="st10" d="M323.1,576.8H24.4c-13.5,0-24.5-11-24.5-24.5v-111c0-13.5,11-24.5,24.5-24.5H155l18.8-32.6l18.8,32.6h130.6
							   				c13.5,0,24.5,11,24.5,24.5v111C347.6,565.8,336.6,576.8,323.1,576.8z M24.4,418.7c-12.4,0-22.5,10.1-22.5,22.5v111
							   				c0,12.4,10.1,22.5,22.5,22.5h298.7c12.4,0,22.5-10.1,22.5-22.5v-111c0-12.4-10.1-22.5-22.5-22.5H191.4l-17.7-30.6L156,418.7H24.4
							   				z"/>
							   		</g>
							   		<rect x="18.3" y="455.2" className="st3" width="311" height="112.7"/>
							   		<text transform="matrix(1 0 0 1 53.8833 473.1911)" className="st10 st4 st11">PJM has more than </text>
							   		<text transform="matrix(1 0 0 1 21.8833 505.5911)" className="st9 st4 st11">185,000 MW</text>
							   		<text transform="matrix(1 0 0 1 180.8833 505.5911)" className="st10 st4 st11"> of installed </text>
							   		<text transform="matrix(1 0 0 1 47.0833 537.9911)" className="st10 st4 st11">generating capacity.</text>
							   	</g>
							   	<g className="summer-circle-item icon-3">
										<linearGradient id="SVGID_00000154411751743368210490000000167489162074629522_" gradientUnits="userSpaceOnUse" x1="101.1158" y1="-36.7295" x2="249.9913" y2="146.2397" gradientTransform="matrix(1 0 0 1 0 188)">
							   			<stop  offset="0" style={{stopColor:"#7FBD1D"}}/>
							   			<stop  offset="2.708180e-04" style={{stopColor:"#7FBD1D"}}/>
							   			<stop  offset="0.2524" style={{stopColor:"#82BD1C"}}/>
							   			<stop  offset="0.424" style={{stopColor:"#8BBD1A"}}/>
							   			<stop  offset="0.5717" style={{stopColor:"#9ABD17"}}/>
							   			<stop  offset="0.7059" style={{stopColor:"#B0BE12"}}/>
							   			<stop  offset="0.8309" style={{stopColor:"#CBBE0C"}}/>
							   			<stop  offset="0.9476" style={{stopColor:"#EDBF04"}}/>
							   			<stop  offset="0.9997" style={{stopColor:"#FFBF00"}}/>
							   			<stop  offset="1" style={{stopColor:"#FFBF00"}}/>
							   		</linearGradient>
							   		<circle className="summer-circle" style={{fill:"url(#SVGID_00000154411751743368210490000000167489162074629522_)"}} cx="173.8" cy="240.6" r="112.5"/>
							   		<g className="rings">
							   			<path id="Stroke-1_00000139263497507941879920000001291055423924237470_" className="st13" d="M173,105.1
							   				c-72.6,0-131.4,58.8-131.4,131.4S100.4,367.9,173,367.9s131.4-58.8,131.4-131.4S245.6,105.1,173,105.1z M173,108.8
							   				c70.5,0,127.7,57.2,127.7,127.7S243.5,364.2,173,364.2S45.3,307,45.3,236.5S102.5,108.8,173,108.8z"/>
							   			<path id="Stroke-3_00000165203283509566773820000015457155943170811057_" className="st14" d="M173,114.3
							   				c-72.6,0-131.4,58.8-131.4,131.4S100.4,377.1,173,377.1s131.4-58.8,131.4-131.4S245.6,114.3,173,114.3z M173,118
							   				c70.5,0,127.7,57.2,127.7,127.7S243.5,373.4,173,373.4S45.3,316.2,45.3,245.7S102.5,118,173,118z"/>
							   		</g>
							   		<path className="center-icon st10" d="M175.2,230.8l18.6-42H184l-45.2,62.5H171l-17,42h9.5l43.7-62.5L175.2,230.8L175.2,230.8z M161.6,289.6h-2.3
							   			l17-42h-30.5l39.9-55.3h2.5l-18.6,42h30.7L161.6,289.6z M127.9,241c0-22.4,16.4-41.3,38.4-44.6l-5.6,7.9l2.9,2.1l9-12.7l-11.8-8.3
							   			l-2.1,2.9l6.5,4.6c-23.5,3.7-41,24.1-41,48.1c0,18.2,10,34.8,26.2,43.2l1.7-3.2C137.2,273.2,127.9,257.9,127.9,241z M182.3,288.8
							   			l7.5,5l-2,3l-12.9-8.7l8-12l3,2l-4.8,7.2c21.3-3.8,37-22.4,37-44.4c0-15.9-8.5-30.8-22.2-38.9l1.8-3.1c14.8,8.7,24,24.8,24,42
							   			C221.7,264.5,205,284.4,182.3,288.8z"/>
							   		<rect x="116.9" y="267.4" className="st3" width="113.8" height="51.6"/>
							   		<g className="icon-text">
								   		<text transform="matrix(1 0 0 1 122.1772 285.3998)" className="st10 st4 st11">185,000 </text>
								   		<text transform="matrix(1 0 0 1 149.2772 312.3998)" className="st10 st4 st11">MW</text>
							   		</g>
							   	</g>
							</g>

	                       	<g className="z10 citem-148" onClick={() => {handleClickSummer(5)}} ref={(element) => {summerItems.current[5] = element}}>
	                       		<g className="text">
	                       			<g>
	                       			<path class="st2" d="M1351.8,423h-131.1l-18.2-31.6l-18.2,31.6h-131.1c-13,0-23.5,10.5-23.5,23.5v281.2
										c0,13,10.5,23.5,23.5,23.5h298.7c13,0,23.5-10.5,23.5-23.5V446.5C1375.3,433.5,1364.8,423,1351.8,423z"/>
									<path class="st10" d="M1351.8,752.2h-298.7c-13.5,0-24.5-11-24.5-24.5V446.5c0-13.5,11-24.5,24.5-24.5h130.6l18.8-32.6
										l18.8,32.6h130.6c13.5,0,24.5,11,24.5,24.5v281.2C1376.3,741.2,1365.3,752.2,1351.8,752.2z M1053.1,424
										c-12.4,0-22.5,10.1-22.5,22.5v281.2c0,12.4,10.1,22.5,22.5,22.5h298.7c12.4,0,22.5-10.1,22.5-22.5V446.5
										c0-12.4-10.1-22.5-22.5-22.5h-131.7l-17.7-30.6l-17.7,30.6H1053.1z"/>
		                       		</g>

		                       		<rect x="1057.8" y="460.5" class="st3" width="289.3" height="271.8"/>
		                       		<text transform="matrix(1 0 0 1 1072.7278 478.4781)"><tspan x="0" y="0" class="st10 st4 st11">Peak demand for the </tspan><tspan x="0.8" y="32.4" class="st10 st4 st11">summer of 2021 was </tspan><tspan x="-12.5" y="64.8" class="st10 st4 st11">approximately </tspan><tspan x="172.2" y="64.8" class="st9 st4 st11">148,770 </tspan><tspan x="14.2" y="97.2" class="st9 st4 st11">MW,</tspan><tspan x="70.4" y="97.2" class="st10 st4 st11"> which was an </tspan><tspan x="21" y="129.6" class="st10 st4 st11">increase from the </tspan><tspan x="16.8" y="162" class="st10 st4 st11">144,588 MW peak </tspan><tspan x="-7.8" y="194.4" class="st10 st4 st11">demand from summer </tspan><tspan x="92.8" y="226.8" class="st10 st4 st11">2020.</tspan></text>
		                       	</g>
		                       	<g className="summer-circle-item icon-6">
		                   			<linearGradient id="SVGID_00000003091392135063935220000002033176604356599970_" gradientUnits="userSpaceOnUse" x1="1145.3542" y1="-13.4554" x2="1323.6757" y2="205.7029" gradientTransform="matrix(1 0 0 1 0 188)">
		                       			<stop  offset="0" style={{stopColor:"#FA0089"}}/>
		                       			<stop  offset="1.000839e-02" style={{stopColor:"#F7038A"}}/>
		                       			<stop  offset="0.2063" style={{stopColor:"#C13DA5"}}/>
		                       			<stop  offset="0.3962" style={{stopColor:"#936DBC"}}/>
		                       			<stop  offset="0.5751" style={{stopColor:"#7092CD"}}/>
		                       			<stop  offset="0.7404" style={{stopColor:"#57ADDA"}}/>
		                       			<stop  offset="0.887" style={{stopColor:"#47BDE1"}}/>
		                       			<stop  offset="1" style={{stopColor:"#42C3E4"}}/>
		                       		</linearGradient>
		                       		<circle className="summer-circle" style={{fill:"url(#SVGID_00000003091392135063935220000002033176604356599970_)"}} cx="1202.6" cy="244.9" r="112.5"/>
		                       		<rect x="1147.5" y="278.7" className="st3" width="113.8" height="51.6"/>
		                       		<g className="icon-text">
			                       		<text transform="matrix(1 0 0 1 1152.8396 296.7291)" className="st10 st4 st11">148,770 </text>
			                       		<text transform="matrix(1 0 0 1 1179.9396 323.7291)" className="st10 st4 st11">MW</text>
		                       		</g>
		                       		<g className="rings">
			                       		<path id="Stroke-1_00000009555392003834548170000017469560904465462434_" className="st13" d="M1201.9,110.6
			                       			c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4s131.4-58.8,131.4-131.4S1274.4,110.6,1201.9,110.6z M1201.9,114.3
			                       			c70.5,0,127.7,57.2,127.7,127.7s-57.2,127.7-127.7,127.7s-127.7-57.2-127.7-127.7S1131.3,114.3,1201.9,114.3z"/>
			                       		<path id="Stroke-3_00000063605466714816755020000000455898748422970271_" className="st14" d="M1201.9,119.8
			                       			c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4s131.4-58.8,131.4-131.4S1274.4,119.8,1201.9,119.8z M1201.9,123.5
			                       			c70.5,0,127.7,57.2,127.7,127.7s-57.2,127.7-127.7,127.7s-127.7-57.2-127.7-127.7S1131.3,123.5,1201.9,123.5z"/>
	                       			</g>
		                       		<path className="center-icon st10" d="M1194.7,273.2h5.6l19.3-27.6h-10.8l4.4-17.1h-5.7l-19.9,27.5h11.2L1194.7,273.2z M1194.7,252.5l13.5-18.7
		                       			l-4,15.5h8.5l-13,18.6l3.7-15.3L1194.7,252.5L1194.7,252.5z M1230.2,218v-28.7c0-4.6-3.7-8.3-8.3-8.3c-4.6,0-8.3,3.7-8.3,8.3V218
		                       			h-21.8v-28.7c0-4.6-3.7-8.3-8.3-8.3c-4.6,0-8.3,3.7-8.3,8.3V218h-7.2v48.8c0,8.7,7,15.7,15.7,15.7h9.7c0,3.3,1.6,6.2,4,8.1v11.7
		                       			h3.6v-9.9c0.9,0.2,1.8,0.4,2.8,0.4s1.9-0.1,2.8-0.4v9.9h3.6v-11.7c2.4-1.9,4-4.8,4-8.1h7.6c8.7,0,15.7-7,15.7-15.7V218H1230.2z
		                       			 M1217.1,189.3c0-2.6,2.1-4.7,4.7-4.7s4.7,2.1,4.7,4.7V218h-9.5v-28.7H1217.1z M1178.7,189.3c0-2.6,2.1-4.7,4.7-4.7
		                       			s4.7,2.1,4.7,4.7V218h-9.5v-28.7H1178.7z M1203.7,289.1c-3.7,0-6.7-3-6.8-6.7h13.6C1210.4,286.2,1207.4,289.1,1203.7,289.1z
		                       			 M1233.8,266.8c0,6.7-5.4,12.1-12.1,12.1h-38.1c-6.7,0-12.1-5.4-12.1-12.1v-45.2h62.3L1233.8,266.8L1233.8,266.8z"/>
		                       	</g>
	                       </g>
	                    </svg>
	                </VisibilitySensor>    
                </div>
                <div style={desktopViewState ? {display: 'none'} : {display: 'block'}} className="mobile-accordion">
                	<div>
						<img className="mobile-header" src={summerMobileHeader} alt="" /> 
            		</div>
                	<div ref={(element) => {accordionItem.current[0] = element}} className="accordion__item citem-185-m">
                		<div onClick={() => {handleClickAccordion(0)}} className="accordion__trigger">
                			<svg 
                				version="1.1" 
                				id="trigger-1"
                				ref={(element) => {triggers.current[0] = element}} 
                				xmlns="http://www.w3.org/2000/svg" 
                				xmlnsXlink="http://www.w3.org/1999/xlink" 
                				x="0px" 
                				y="0px"
                				viewBox="0 0 206.7 213.9" 
                				style={{enableBackground:'new 0 0 206.7 213.9'}} 
                				xmlSpace="preserve">
	                			<g id="Layer_1_00000078003727570719184850000006826919576985585849_">
	                			</g>
	                			<g>
	                				<g className="summer-circle-item">
	                					<linearGradient id="trigger1" gradientUnits="userSpaceOnUse" x1="45.0271" y1="35.3129" x2="164.1275" y2="181.6883">
	                						<stop  offset="0" style={{stopColor:"#7FBD1D"}}/>
	                						<stop  offset="2.708180e-04" style={{stopColor:"#7FBD1D"}}/>
	                						<stop  offset="0.2524" style={{stopColor:"#82BD1C"}}/>
	                						<stop  offset="0.424" style={{stopColor:"#8BBD1A"}}/>
	                						<stop  offset="0.5717" style={{stopColor:"#9ABD17"}}/>
	                						<stop  offset="0.7059" style={{stopColor:"#B0BE12"}}/>
	                						<stop  offset="0.8309" style={{stopColor:"#CBBE0C"}}/>
	                						<stop  offset="0.9476" style={{stopColor:"#EDBF04"}}/>
	                						<stop  offset="0.9997" style={{stopColor:"#FFBF00"}}/>
	                						<stop  offset="1" style={{stopColor:"#FFBF00"}}/>
	                					</linearGradient>
	                					<circle className="summer-circle st0" style={{fill:'url(#trigger1)'}} cx="103.2" cy="106.8" r="90" />
	                					<g className="icon">
	                						<path className="st1" d="M104.7,96.9l14.6-33h-7.7L76.1,113h25.3L88,146h7.5l34.4-49.1H104.7z M94,143.2h-1.8l13.4-33h-24L113,66.7
	                							h1.9l-14.6,33h24.1L94,143.2z"/>
	                						<path className="st1" d="M67.5,104.9c0-17.6,12.9-32.5,30.2-35.1l-4.4,6.2l2.3,1.6l7-10l-9.3-6.5l-1.6,2.3l5.1,3.6
	                							C78.5,70,64.7,86,64.7,104.9c0,14.3,7.9,27.3,20.6,34l1.3-2.5C74.8,130.2,67.5,118.2,67.5,104.9z"/>
	                						<path className="st1" d="M141.3,104.9c0-13.5-7.2-26.1-18.9-33l-1.4,2.4c10.8,6.4,17.5,18.1,17.5,30.6c0,17.3-12.4,31.9-29.1,34.9
	                							l3.8-5.6l-2.3-1.6l-6.3,9.4l10.2,6.8l1.6-2.3l-5.9-4C128.2,139.1,141.3,123.4,141.3,104.9z"/>
	                					</g>
	                					<g className="rings">
	                						<g id="Group-5_00000107564667594854481320000006160154446555770791_" transform="translate(-3.000000, -3.000000)">
	                							<path id="Stroke-1_00000119110334722504348330000017777837885537397399_" className="st2" d="M106,3C48.9,3,2.7,49.3,2.7,106.4
	                								S48.9,209.7,106,209.7c57.1,0,103.3-46.3,103.3-103.3S163.1,3,106,3z M106,6c55.5,0,100.4,45,100.4,100.4s-45,100.4-100.4,100.4
	                								c-55.5,0-100.4-45-100.4-100.4S50.5,6,106,6z"/>
	                							<path id="Stroke-3_00000005974331938834811630000002074094466634307236_" className="st3" d="M106,10.3
	                								C48.9,10.3,2.7,56.6,2.7,113.6S48.9,217,106,217c57.1,0,103.3-46.3,103.3-103.3S163.1,10.3,106,10.3z M106,13.2
	                								c55.5,0,100.4,45,100.4,100.4S161.5,214,106,214c-55.5,0-100.4-45-100.4-100.4S50.5,13.2,106,13.2z"/>
	                						</g>
	                					</g>
	                				</g>
	                				<g className="icon-text">
		                				<rect x="59.3" y="129.6" className="st4" width="88" height="39.9"/>
		                				<text transform="matrix(1 0 0 1 63.3759 143.5507)"><tspan x="0" y="0" className="st1 st5 st6">185,000 </tspan><tspan x="21" y="20.9" className="st1 st5 st6">MW</tspan></text>
	                				</g>
	                			</g>
                			</svg>

                		</div>
                		<div className="accordion__content">
                			<div className="speech-bubble">
                				<div className="text">PJM has more than <span className="text--yellow">185,000 MW</span> of installed generating capacity.</div>
            				</div>
                		</div>
                	</div>
                	<div ref={(element) => {accordionItem.current[1] = element}} className="accordion__item citem-800-m">
                		<div onClick={() => {handleClickAccordion(1)}} className="accordion__trigger">
                			<svg 
                				version="1.1" 
                				id="trigger-2"
                				ref={(element) => {triggers.current[1] = element}} 
                				xmlns="http://www.w3.org/2000/svg" 
                				xmlnsXlink="http://www.w3.org/1999/xlink" 
                				x="0px" 
                				y="0px"
                				viewBox="0 0 206.1 213.3" 
                				style={{enableBackground:"new 0 0 206.1 213.3"}} 
                				xmlSpace="preserve">
	                			<g id="Layer_1_00000142864661264118651980000011033054607433596074_">
	                			</g>
	                			<g>
	                				<g className="summer-circle-item">
	                					<linearGradient id="trigger2" gradientUnits="userSpaceOnUse" x1="56.7947" y1="51.3514" x2="199.4519" y2="226.6782">
	                						<stop  offset="0" style={{stopColor:"#FA0089"}}/>
	                						<stop  offset="1.000839e-02" style={{stopColor:"#F7038A"}}/>
	                						<stop  offset="0.2063" style={{stopColor:"#C13DA5"}}/>
	                						<stop  offset="0.3962" style={{stopColor:"#936DBC"}}/>
	                						<stop  offset="0.5751" style={{stopColor:"#7092CD"}}/>
	                						<stop  offset="0.7404" style={{stopColor:"#57ADDA"}}/>
	                						<stop  offset="0.887" style={{stopColor:"#47BDE1"}}/>
	                						<stop  offset="1" style={{stopColor:"#42C3E4"}}/>
	                					</linearGradient>
	                					<circle className="summer-circle" style={{fill: 'url(#trigger2)'}} cx="102.6" cy="107.7" r="90"/>
	                					<g className="rings">
	                						<g id="Group-5_00000130627784896710943910000001046895191693375409_" transform="translate(-3.000000, -3.000000)">
	                							<path id="Stroke-1_00000062175513507018308860000008172931174407300021_" className="st1" d="M106,3.3C49.1,3.3,3,49.5,3,106.4
	                								s46.1,103,103,103c56.9,0,103-46.1,103-103S162.9,3.3,106,3.3z M106,6.3c55.3,0,100.1,44.8,100.1,100.1S161.3,206.5,106,206.5
	                								c-55.3,0-100.1-44.8-100.1-100.1S50.7,6.3,106,6.3z"/>
	                							<path id="Stroke-3_00000067202676846739981450000005914784805358478771_" className="st2" d="M106,10.6c-56.9,0-103,46.1-103,103
	                								s46.1,103,103,103c56.9,0,103-46.1,103-103S162.9,10.6,106,10.6z M106,13.5c55.3,0,100.1,44.8,100.1,100.1
	                								S161.3,213.7,106,213.7c-55.3,0-100.1-44.8-100.1-100.1S50.7,13.5,106,13.5z"/>
	                						</g>
	                					</g>
	                					<g className="icon">
	                						<path className="st3" d="M142.7,104.6v-2.2L103,69.8L87.6,82.4v-4.3h-8.9v11.6l-15.4,12.6v2.3h9.8v32.7h-8.4v2.8h8.4h7.1h16.6h34.6
	                							h9.8v-2.8h-8.9V128c0,0,0-0.4,0-1.1c0.8-0.1,1.6-0.4,2.3-0.9c1.1-0.8,2-2,2.6-3.5c0.5-1.3,0.4-3,0.3-4.4l0-0.4
	                							c-0.2-3.2,0.3-4.5,1.3-7.1l1.2-3.2l-2.3,0.2c-3.1,0.3-6.2,1.6-8.7,3.6c-1.5,1.2-3.4,3.3-4.1,6.2c-0.7,2.8,0,5.6,1.8,7.5
	                							c0.8,0.8,1.7,1.3,2.7,1.7c0,0.8,0,1.3,0,1.3v9.3H96.9v-26.8H80.2v26.8H76v-33.8l27-22.3l28.4,23.4H142.7z M128.9,123.1
	                							c-1.1-1.2-1.5-3.1-1.1-4.9c0.5-2.1,2-3.7,3.2-4.7c1.4-1.2,3.1-2,4.8-2.5c-0.7,2-1.1,3.8-1,6.9l0,0.4c0,0.9,0.1,2.5-0.1,3.2
	                							c-0.2,0.7-0.7,1.6-1.5,2.1c-0.2,0.1-0.4,0.2-0.6,0.3c0.1-1.7,0.3-3.6,0.7-5.1l-2.7-0.7c-0.4,1.6-0.6,3.6-0.8,5.4
	                							C129.4,123.5,129.2,123.3,128.9,123.1z M83.1,113.3h11v24h-11V113.3z M81.5,80.9h3.3v3.8l-3.3,2.7V80.9z M73.6,101.8h-5.2
	                							L103,73.5l34.5,28.3h-5.2L103,77.6L73.6,101.8z"/>
	                						<path className="st3" d="M102.7,110.5v13.7h-3v2.8h3h17.5h2.9v-2.8h-2.9v-13.7H102.7z M105.6,124.2v-10.9h11.9v10.9H105.6z"/>
	                					</g>
	                				</g>
	                				<g className="icon-text">
		                				<rect x="59.3" y="127.1" className="st4" width="88" height="39.9"/>
		                				<text transform="matrix(1 0 0 1 83.8262 141.0521)"><tspan x="0" y="0" className="st3 st5 st6">800 </tspan><tspan x="-17.9" y="20.9" className="st3 st5 st6">HOMES</tspan></text>
		                			</g>
	                			</g>
                			</svg>

                		</div>
                		<div className="accordion__content">
                			<div className="speech-bubble">
                				<div className="text">1 MW powers about <span className="text--yellow">800 homes</span>.</div>
            				</div>
                		</div>
                	</div>
                	<div ref={(element) => {accordionItem.current[2] = element}} className="accordion__item citem-165-m">
                		<div onClick={() => {handleClickAccordion(2)}} className="accordion__trigger">
							<svg 
								version="1.1" 
								id="trigger-3"
								ref={(element) => {triggers.current[2] = element}} 
								xmlns="http://www.w3.org/2000/svg" 
								xmlnsXlink="http://www.w3.org/1999/xlink" 
								x="0px" 
								y="0px"
								viewBox="0 0 206.6 213.9" 
								style={{enableBackground:"new 0 0 206.6 213.9"}} 
								xmlSpace="preserve">
								<g id="Layer_1_00000093888726866573074020000013669876789956993923_">
								</g>
								<g>
									<g className="summer-circle-item">
										<linearGradient id="trigger3" gradientUnits="userSpaceOnUse" x1="45.5495" y1="35.4913" x2="164.65" y2="181.8667">
											<stop  offset="0" style={{stopColor:"#7FBD1D"}}/>
											<stop  offset="2.708180e-04" style={{stopColor:"#7FBD1D"}}/>
											<stop  offset="0.2524" style={{stopColor:"#82BD1C"}}/>
											<stop  offset="0.424" style={{stopColor:"#8BBD1A"}}/>
											<stop  offset="0.5717" style={{stopColor:"#9ABD17"}}/>
											<stop  offset="0.7059" style={{stopColor:"#B0BE12"}}/>
											<stop  offset="0.8309" style={{stopColor:"#CBBE0C"}}/>
											<stop  offset="0.9476" style={{stopColor:"#EDBF04"}}/>
											<stop  offset="0.9997" style={{stopColor:"#FFBF00"}}/>
											<stop  offset="1" style={{stopColor:"#FFBF00"}}/>
										</linearGradient>
										<circle className="summer-circle" style={{fill: 'url(#trigger3)'}} cx="103.7" cy="106.9" r="90"/>
										<g className="rings">
											<g id="Group-5_00000155835771147680807390000010659926111612278714_" transform="translate(-3.000000, -3.000000)">
												<path id="Stroke-1_00000130636858600051582260000015874696471166137018_" className="st1" d="M106,3.1C48.9,3.1,2.7,49.3,2.7,106.4
													S48.9,209.7,106,209.7c57.1,0,103.3-46.3,103.3-103.3S163.1,3.1,106,3.1z M106,6c55.4,0,100.4,45,100.4,100.4
													s-45,100.4-100.4,100.4c-55.4,0-100.4-45-100.4-100.4S50.6,6,106,6z"/>
												<path id="Stroke-3_00000056391381003946293430000009983382900329148863_" className="st2" d="M106,10.3
													C48.9,10.3,2.7,56.6,2.7,113.6S48.9,216.9,106,216.9c57.1,0,103.3-46.3,103.3-103.3S163.1,10.3,106,10.3z M106,13.2
													c55.4,0,100.4,45,100.4,100.4S161.4,214,106,214c-55.4,0-100.4-45-100.4-100.4S50.6,13.2,106,13.2z"/>
											</g>
										</g>
										<g className="icon">
											<path className="st3" d="M101.1,99.6l13.1-29.6H107l-32,44.3h22.7l-12,29.6h7l31-44.3H101.1z M91.3,141.1h-1.3l12-29.6H80.5
												l27.9-38.6h1.4l-13.1,29.6h21.5L91.3,141.1z"/>
											<path className="st3" d="M86.6,128.9H57.4c-0.5,0-0.9-0.4-0.9-0.9V86c0-0.5,0.4-0.9,0.9-0.9h34.8v-2.8H57.4c-2.1,0-3.7,1.7-3.7,3.7
												v42c0,2.1,1.7,3.7,3.7,3.7h29.1V128.9z"/>
											<path className="st3" d="M150.3,95h-5.2v-9c0-2.1-1.7-3.7-3.7-3.7h-28.9v2.8h28.9c0.5,0,0.9,0.4,0.9,0.9v9h0V119h0v9
												c0,0.5-0.4,0.9-0.9,0.9h-33.8v2.8h33.8c2.1,0,3.7-1.7,3.7-3.7v-9h5.2c1.1,0,2-0.9,2-2V96.9C152.3,95.9,151.4,95,150.3,95z
												 M149.5,116.2h-4.4V97.8h4.4V116.2z"/>
											<path className="st3" d="M62,90c-0.9,0-1.7,0.8-1.7,1.7v30.1c0,0.9,0.8,1.7,1.7,1.7h9.8c0.9,0,1.7-0.8,1.7-1.7V91.7
												c0-0.9-0.8-1.7-1.7-1.7H62z M70.7,120.7h-7.5V92.8h7.5V120.7z"/>
											<path className="st3" d="M77.2,117.9v3.8c0,1,0.8,1.9,1.9,1.9h9.4c1,0,1.9-0.8,1.9-1.9v-3.8h-2.8v2.8h-7.5v-2.8H77.2z"/>
											<path className="st3" d="M77.2,91.8v9.7h2.8v-8.7h6.5V90h-7.5C78.1,90,77.2,90.8,77.2,91.8z"/>
											<path className="st3" d="M112.4,120.7v2.8h7.6c1,0,1.9-0.8,1.9-1.9v-10.4H119v9.4H112.4z"/>
											<path className="st3" d="M121.8,96.7v-4.8c0-1-0.8-1.9-1.9-1.9h-9.4c-1,0-1.9,0.8-1.9,1.9v4.8h2.8v-3.8h7.5v3.8H121.8z"/>
											<path className="st3" d="M137.1,123.5c0.9,0,1.7-0.8,1.7-1.7V91.7c0-0.9-0.8-1.7-1.7-1.7h-9.8c-0.9,0-1.7,0.8-1.7,1.7v30.1
												c0,0.9,0.8,1.7,1.7,1.7H137.1z M128.4,92.8h7.5v27.9h-7.5V92.8z"/>
										</g>
									</g>
									<g className="icon-text">
										<rect x="61.4" y="129.4" className="st4" width="88" height="39.9"/>
										<text transform="matrix(1 0 0 1 65.8791 143.3314)"><tspan x="0" y="0" className="st3 st5 st6">165,563 </tspan><tspan x="20.6" y="20.9" className="st3 st5 st6">MW</tspan></text>
									</g>
								</g>
							</svg>

                		</div>
                		<div className="accordion__content">
                			<div className="speech-bubble">
                				<div className="text">PJM’s all-time, one-day highest power use was set in 2006 at <span className="text--yellow">165,563 MW</span>.</div>
            				</div>
                		</div>
                	</div>
                	<div ref={(element) => {accordionItem.current[3] = element}} className="accordion__item citem-144-m">
                		<div onClick={() => {handleClickAccordion(3)}} className="accordion__trigger">
                			<svg 
                				version="1.1" 
                				id="trigger-4"
                				ref={(element) => {triggers.current[3] = element}} 
                				xmlns="http://www.w3.org/2000/svg" 
                				xmlnsXlink="http://www.w3.org/1999/xlink" 
                				x="0px" 
                				y="0px"
                				viewBox="0 0 208.7 216" 
                				style={{enableBackground:"new 0 0 208.7 216"}} 
                				xmlSpace="preserve">
								<g id="Layer_1_00000021837354089641765610000009968301165269918859_">
								</g>
								<g>
									<g className="summer-circle-item">
										<linearGradient id="trigger4" gradientUnits="userSpaceOnUse" x1="57.5425" y1="51.7014" x2="176.643" y2="198.0768">
											<stop  offset="0" style={{stopColor:"#42C3E4"}}/>
											<stop  offset="0.1714" style={{stopColor:"#42C3E4"}}/>
											<stop  offset="0.2633" style={{stopColor:"#44C3DE"}}/>
											<stop  offset="0.3836" style={{stopColor:"#49C2CE"}}/>
											<stop  offset="0.5195" style={{stopColor:"#51C2B3"}}/>
											<stop  offset="0.6669" style={{stopColor:"#5DC08D"}}/>
											<stop  offset="0.8236" style={{stopColor:"#6BBF5D"}}/>
											<stop  offset="0.9859" style={{stopColor:"#7DBD22"}}/>
											<stop  offset="1" style={{stopColor:"#7FBD1D"}}/>
										</linearGradient>
										<circle className="summer-circle" style={{fill: "url(#trigger4)"}} cx="103.4" cy="108" r="90"/>
										<g className="rings">
											<g id="Group-5_00000174584780036613769910000002290477893652567968_" transform="translate(-3.000000, -3.000000)">
												<path id="Stroke-1_00000045578987329372586020000015603031276681162125_" className="st1" d="M107,3C49.4,3,2.7,49.7,2.7,107.3
													S49.4,211.7,107,211.7c57.6,0,104.3-46.7,104.3-104.3S164.6,3,107,3z M107,5.9c56,0,101.4,45.4,101.4,101.4S163,208.7,107,208.7
													c-56,0-101.4-45.4-101.4-101.4S51,5.9,107,5.9z"/>
												<path id="Stroke-3_00000018239316301141171190000012121776819440983733_" className="st2" d="M107,10.3C49.4,10.3,2.7,57,2.7,114.7
													S49.4,219,107,219c57.6,0,104.3-46.7,104.3-104.3S164.6,10.3,107,10.3z M107,13.3c56,0,101.4,45.4,101.4,101.4
													S163,216.1,107,216.1c-56,0-101.4-45.4-101.4-101.4S51,13.3,107,13.3z"/>
											</g>
										</g>
										<g className="icon">
											<path className="st3" d="M152.6,88c1.8,0,3.4-0.7,4.7-1.9c1.3-1.2,1.9-2.9,1.9-4.7c0-1.8-0.7-3.4-1.9-4.7c-1.1-1.1-2.4-1.7-3.9-1.9
										c-0.1-3-1.3-5.9-3.4-8.1c-2.2-2.2-5.2-3.4-8.3-3.4c0,0,0,0,0,0c-5.8,0-10.5,4.1-11.5,9.6c-0.2,0-0.3,0-0.5,0c0,0,0,0,0,0
										c-2.3,0-4.5,1.1-5.9,2.8l-4.7-6.9l-20.7,33.8L89,88.8l-4.5,6.7c-0.6-1.8-1.5-3.5-2.9-4.8c-2.2-2.2-5.2-3.4-8.3-3.4c0,0,0,0,0,0
										c-5.8,0-10.5,4.1-11.5,9.6c-3.1-0.2-6,1.6-7.3,4.4c-0.5,1-0.7,2.1-0.7,3.1c0,2,0.8,3.9,2.2,5.3c1.4,1.4,3.3,2.2,5.3,2.2l12.1,0
										l-19.4,28.6l2.5,1.7l21.4-31.5l6.5,6.5l4.7-5.8l4.7,5.8l6.5-6.5l21.5,31.8l2.5-1.7l-24-35.4l8-13.1l6.2,6.2l4.7-5.8l4.7,5.8l7-7
										l21.3,31.4l2.5-1.7L132,88L152.6,88C152.6,88,152.6,88,152.6,88z M61.2,108.9c-1.2,0-2.3-0.5-3.2-1.3c-0.8-0.8-1.3-2-1.3-3.2
										c0-0.6,0.1-1.3,0.4-1.9c0.7-1.6,2.3-2.6,4.1-2.6c0.4,0,0.8,0.1,1.4,0.2l1.9,0.6l0.1-2c0.1-4.7,3.9-8.4,8.7-8.4c0,0,0,0,0,0
										c2.3,0,4.5,0.9,6.1,2.5c1.6,1.6,2.5,3.8,2.5,6.1c0,0.1,0,0.2,0,0.3l-6.5,9.6L61.2,108.9z M93.9,112.7l-4.9-6.1l-4.9,6.1l-4.3-4.3
										l-0.9,0.9l5.9-8.7l0.1,0c0-0.1,0-0.1,0-0.2l4.1-6.1l9.4,13.9L93.9,112.7z M128.9,89.1L124,94l-4.9-6.1l-4.9,6.1l-4.3-4.3l0,0
										l9.3-15.2l10.3,15.2L128.9,89.1z M125.6,78.4c0.8-1.5,2.3-2.5,4-2.5c0,0,0,0,0,0c0.4,0,0.9,0.1,1.4,0.2l1.9,0.6l0.1-2
										c0.1-4.7,3.9-8.4,8.7-8.4c0,0,0,0,0,0c2.3,0,4.5,0.9,6.1,2.5s2.5,3.8,2.5,6.1c0,0.4,0,0.8-0.1,1.1l-0.3,2.1l2.1-0.4
										c0.2,0,0.4-0.1,0.6-0.1c2,0,3.5,1.6,3.5,3.5c0,0.9-0.4,1.8-1,2.5c-0.7,0.7-1.6,1-2.5,1c0,0,0,0,0,0l-22.6,0L125.6,78.4z"/>
											
										</g>
									</g>
									<g className="icon-text">
										<rect x="61" y="134.7" className="st4" width="88" height="39.9"/>
										<text transform="matrix(1 0 0 1 65.098 148.6755)"><tspan x="0" y="0" className="st3 st5 st6">144,000 </tspan><tspan x="20.9" y="20.9" className="st3 st5 st6">MW</tspan></text>
									</g>
								</g>
							</svg>

                		</div>
                		<div className="accordion__content">
                			<div className="speech-bubble">
                				<div className="text">In 2020, COVID-related impacts decreased summer demand, resulting in a peak of approximately <span className="text--yellow">144,000 MW</span>.</div>
            				</div>
                		</div>
                	</div>
                	<div ref={(element) => {accordionItem.current[4] = element}} className="accordion__item citem-149-m">
                		<div onClick={() => {handleClickAccordion(4)}} className="accordion__trigger">
							<svg 
								version="1.1" 
								id="trigger-5"
								ref={(element) => {triggers.current[4] = element}} 
								xmlns="http://www.w3.org/2000/svg" 
								xmlnsXlink="http://www.w3.org/1999/xlink" 
								x="0px" 
								y="0px"
								viewBox="0 0 208.8 216.1" 
								style={{enableBackground:"new 0 0 208.8 216.1"}} 
								xmlSpace="preserve">
								<g id="Layer_1_00000098905141706608738480000004120071983009275271_">
								</g>
								<g>
									<g>
										<g className="summer-circle-item">
											<linearGradient id="trigger5" gradientUnits="userSpaceOnUse" x1="69.4181" y1="152.0114" x2="224.6978" y2="-38.8286" gradientTransform="matrix(1 0 0 -1 0 218)">
												<stop  offset="0" style={{stopColor:"#FFC000"}}/>
												<stop  offset="0.1129" style={{stopColor:"#FEB906"}}/>
												<stop  offset="0.2803" style={{stopColor:"#FAA515"}}/>
												<stop  offset="0.4816" style={{stopColor:"#F5842E"}}/>
												<stop  offset="0.7093" style={{stopColor:"#ED5651"}}/>
												<stop  offset="0.9561" style={{stopColor:"#E41C7D"}}/>
												<stop  offset="1" style={{stopColor:"#E21185"}}/>
											</linearGradient>
											<ellipse className="summer-circle" style={{fill: 'url(#trigger5)'}} cx="103.6" cy="108" rx="90" ry="90"/>
										
											<g className="icon">
												
													<rect x="83.3" y="133.9" transform="matrix(0.4999 -0.8661 0.8661 0.4999 -74.0452 142.4942)" className="st1" width="6.1" height="2.9"/>
												
													<rect x="118.6" y="72.8" transform="matrix(0.4999 -0.8661 0.8661 0.4999 -3.4816 142.5543)" className="st1" width="6.1" height="2.9"/>
												
													<rect x="70.4" y="121" transform="matrix(0.8661 -0.4999 0.4999 0.8661 -51.3813 53.119)" className="st1" width="6.1" height="2.9"/>
												
													<rect x="131.5" y="85.8" transform="matrix(0.8661 -0.4999 0.4999 0.8661 -25.5904 78.959)" className="st1" width="6.1" height="2.9"/>
												<rect x="65.7" y="103.4" className="st1" width="6.1" height="2.9"/>
												<rect x="136.2" y="103.4" className="st1" width="6.1" height="2.9"/>
												<rect x="72" y="84.1" transform="matrix(0.5 -0.866 0.866 0.5 -38.7952 107.18)" className="st1" width="2.9" height="6.1"/>
												<rect x="133.1" y="119.4" transform="matrix(0.5 -0.866 0.866 0.5 -38.7633 177.7344)" className="st1" width="2.9" height="6.1"/>
												<rect x="84.9" y="71.2" transform="matrix(0.866 -0.5 0.5 0.866 -25.565 53.1181)" className="st1" width="2.9" height="6.1"/>
												<rect x="120.2" y="132.3" transform="matrix(0.866 -0.5 0.5 0.866 -51.3691 78.9562)" className="st1" width="2.9" height="6.1"/>
												<rect x="102.6" y="66.5" className="st1" width="2.9" height="6.1"/>
												<rect x="102.6" y="137" className="st1" width="2.9" height="6.1"/>
												<path className="st1" d="M104,77.3c-15.2,0-27.5,12.3-27.5,27.5s12.3,27.5,27.5,27.5s27.5-12.3,27.5-27.5
													C131.5,89.7,119.2,77.3,104,77.3z M104,129.4c-13.6,0-24.6-11-24.6-24.6s11-24.6,24.6-24.6s24.6,11,24.6,24.6
													S117.6,129.4,104,129.4z"/>
												<path className="st1" d="M85.7,104.8h2.9c0-8.5,6.9-15.4,15.4-15.4v-2.9C93.9,86.5,85.7,94.7,85.7,104.8z"/>
											</g>
											<g className="rings">
												<g id="Group-5_00000018951821807333135610000005723308776889321625_" transform="translate(-3.000000, -3.000000)">
													<path id="Stroke-1_00000109710327846492539470000009968784666530991266_" className="st2" d="M107,2.9C49.3,2.9,2.6,49.7,2.6,107.3
														S49.3,211.7,107,211.7S211.4,165,211.4,107.3S164.7,2.9,107,2.9z M107,5.9c56,0,101.5,45.4,101.5,101.5S163,208.8,107,208.8
														S5.5,163.4,5.5,107.3S51,5.9,107,5.9z"/>
													<path id="Stroke-3_00000018959412492489881170000005780144468234234779_" className="st3" d="M107,10.3C49.3,10.3,2.6,57,2.6,114.7
														S49.3,219.1,107,219.1s104.4-46.7,104.4-104.4S164.7,10.3,107,10.3z M107,13.2c56,0,101.5,45.4,101.5,101.5S163,216.1,107,216.1
														S5.5,170.7,5.5,114.6S51,13.2,107,13.2z"/>
												</g>
											</g>
										</g>
									</g>
									<g className="icon-text">
										<rect x="59.3" y="131.8" className="st4" width="88" height="39.9"/>
										<text transform="matrix(1 0 0 1 63.3807 145.7116)" className="st1 st5 st6">149,000 </text>
										<text transform="matrix(1 0 0 1 84.3807 166.6116)" className="st1 st5 st6">MW</text>
									</g>
								</g>
							</svg>


                		</div>
                		<div className="accordion__content">
                			<div className="speech-bubble">
                				<div className="text">PJM forecasted the 2021 summer peak to be about <span className="text--yellow">149,000 MW</span>.</div>
            				</div>
                		</div>
                	</div>
                	<div ref={(element) => {accordionItem.current[5] = element}} className="accordion__item citem-148-m">
                		<div onClick={() => {handleClickAccordion(5)}} className="accordion__trigger">
							<svg 
								version="1.1" 
								id="trigger-6"
								ref={(element) => {triggers.current[5] = element}} 
								xmlns="http://www.w3.org/2000/svg" 
								xmlnsXlink="http://www.w3.org/1999/xlink" 
								x="0px"
								y="0px"
								viewBox="0 0 205.4 212.7" 
								style={{enableBackground:"new 0 0 205.4 212.7"}} 
								xmlSpace="preserve">
								<g id="Layer_1_00000010998386072505163720000012064922540854330003_">
								</g>
								<g>
									<g className="summer-circle-item">
										<linearGradient id="trigger6" gradientUnits="userSpaceOnUse" x1="57.2152" y1="49.029" x2="199.8724" y2="224.3557">
											<stop  offset="0" style={{stopColor:"#FA0089"}}/>
											<stop  offset="1.000839e-02" style={{stopColor:"#F7038A"}}/>
											<stop  offset="0.2063" style={{stopColor:"#C13DA5"}}/>
											<stop  offset="0.3962" style={{stopColor:"#936DBC"}}/>
											<stop  offset="0.5751" style={{stopColor:"#7092CD"}}/>
											<stop  offset="0.7404" style={{stopColor:"#57ADDA"}}/>
											<stop  offset="0.887" style={{stopColor:"#47BDE1"}}/>
											<stop  offset="1" style={{stopColor:"#42C3E4"}}/>
										</linearGradient>
										<circle className="summer-circle" style={{fill: 'url(#trigger6)'}} cx="103" cy="105.3" r="90"/>
										<g className="rings">
											<g id="Group-5_00000042009443057740604770000010264769541442624899_" transform="translate(-3.000000, -3.000000)">
												<path id="Stroke-1_00000062161714318594142190000017010133268800348053_" className="st1" d="M106,2.7C49.3,2.7,3.3,48.7,3.3,105.4
													s46,102.7,102.7,102.7c56.7,0,102.7-46,102.7-102.7S162.7,2.7,106,2.7z M106,5.6c55.1,0,99.8,44.7,99.8,99.8
													s-44.7,99.8-99.8,99.8c-55.1,0-99.8-44.7-99.8-99.8S50.9,5.6,106,5.6z"/>
												<path id="Stroke-3_00000092438348274621909840000013199561414742640522_" className="st2" d="M106,9.9C49.3,9.9,3.3,55.9,3.3,112.6
													s46,102.7,102.7,102.7c56.7,0,102.7-46,102.7-102.7S162.7,9.9,106,9.9z M106,12.8c55.1,0,99.8,44.7,99.8,99.8
													s-44.7,99.8-99.8,99.8c-55.1,0-99.8-44.7-99.8-99.8S50.9,12.8,106,12.8z"/>
											</g>
										</g>
										<g className="icon">
											<path className="st3" d="M97.4,130.7h4.4l15.1-21.5h-8.4l3.5-13.4h-4.5l-15.6,21.5h8.8L97.4,130.7z M97.4,114.5L108,99.9l-3.1,12.1
												h6.7l-10.2,14.5l2.9-12H97.4z"/>
											<path className="st3" d="M125.2,87.6V65.1c0-3.6-2.9-6.5-6.5-6.5c-3.6,0-6.5,2.9-6.5,6.5v22.4H95.1V65.1c0-3.6-2.9-6.5-6.5-6.5
												c-3.6,0-6.5,2.9-6.5,6.5v22.4h-5.6v38.1c0,6.8,5.5,12.3,12.3,12.3h7.6c0,2.6,1.3,4.8,3.1,6.3v9.1h2.8v-7.7
												c0.7,0.2,1.4,0.3,2.2,0.3c0.7,0,1.5-0.1,2.2-0.3v7.7h2.8v-9.1c1.9-1.5,3.1-3.7,3.1-6.3h5.9c6.8,0,12.3-5.5,12.3-12.3V87.6H125.2z
												 M114.9,65.1c0-2,1.7-3.7,3.7-3.7c2,0,3.7,1.7,3.7,3.7v22.4h-7.4V65.1z M84.9,65.1c0-2,1.7-3.7,3.7-3.7s3.7,1.7,3.7,3.7v22.4
												h-7.4V65.1z M104.4,143.1c-2.9,0-5.2-2.3-5.3-5.2h10.6C109.7,140.8,107.3,143.1,104.4,143.1z M127.9,125.7c0,5.2-4.2,9.5-9.5,9.5
												H88.7c-5.2,0-9.5-4.2-9.5-9.5V90.4h48.7V125.7z"/>
										</g>
									</g>
									<g className="icon-text">
										<rect x="58.7" y="136.8" className="st4" width="88" height="39.9"/>
										<text transform="matrix(1 0 0 1 62.8464 150.7697)"><tspan x="0" y="0" className="st3 st5 st6">148,770 </tspan><tspan x="21" y="20.9" className="st3 st5 st6">MW</tspan></text>
									</g>
								</g>
							</svg>


                		</div>
                		<div className="accordion__content">
                			<div className="speech-bubble">
                				<div className="text">Peak demand for the summer of 2021 was approximately <span className="text--yellow">148,770 MW,</span> which was an increase from the 144,588 MW peak demand from summer 2020.</div>
            				</div>
                		</div>
                	</div>

                </div>
            </div>
	    </div>
	)
}